import moment from 'moment'
import _, { cloneDeep } from 'lodash'
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Triagem, Autorizacao, Agendamento, PreAnestesia, Suprimentos, SolicitacaoCirurgiaImp } from '@/types/core'
// eslint-disable-next-line
import {
  ProtocoloOpmeMessage,
  Hemocomponente,
  NovaDataSolicitada,
  ReservaHemocomponente,
  Solicitacao,
  Acoes,
  AgendamentoTriagemConfirmar,
  SendReservaSala,
  TipoDocumentoUpload,
  Anestesista,
  ReservaHemocomponenteAnestesista,
  ContestacaoMedica,
  ContestacaoMedicaMensagem,
  TipoEnvioMensagemEnum,
  Equipamento,
  Procedimento,
  BackofficeGlobalModal,
  Hospital,
  Convenio,
  Plano,
  Paciente,
  SolicitacaoCirurgia,
  TempoDeDoenca,
  NovoFornecedor,
  NovoOPME,
  GrupoOpme,
  GrupoOpmes,
  ModalSolicitacaoCirurgia,
  FornecedorOPME,
  ProcedimentoInternacaoOperadora,
  AgendamentoSolicitacaoItem,
  OpmeMaterial,
  CaixaCirurgica,
  AnestesistaHospital,
  MedicoDoHis,
  PowerBiReportType,
  ClassificacaoAsaEnum,
  // eslint-disable-next-line
} from '@/types/_'
import { getRoute, timeout, setOPMEsToSave, formatPhoneMask, formatProcedimentosUpdateSolicitacao, flatPhone, setMateriaisCotadosOpme, getOpmesApagados, opcaoHabilitadoShared, campoHabilitadoShared, getProcedimentoIdFromProcedimentos, formatHemocomponenteName } from '@/utils/common'
import { EquipamentoGrupo, EquipamentoGrupoChild, EquipamentoGrupoDaSolicitacao, SolicitacaoGrupoOpme } from '@/types/interfaces/Solicitacao'
import { SolicitacaoOpme } from '@/types/interfaces/protocolo/protocolo.interface'
import Apis from '@/Apis/_'
import { Pais } from '@/components/Suporte/Store/SuportePaisesStore'
import { backofficeSharedDataService } from './backoffice-shared-data-service'

@Module({ namespaced: true, name: 'BackofficeGlobalStore' })
export default class BackofficeGlobalStore extends VuexModule {
  solicitationFromList?: Solicitacao = {} as Solicitacao
  backofficeArea?: string | null = null

  public modal: BackofficeGlobalModal = {
    preAgendamento: false,
    revisaoCirurgica: false,
    revisaoCirurgicaAutorizacao: false,
    pendenciaAdministrativa: false,
    triagem: false,
    iniciarProcesso: false,
    visualizacao: false,
    visualizacaoAT: false,
    autorizarProcesso: false,
    realizarAvaliacao: false,
    atualizarAvaliacao: false,
    atualizarPrecificacao: false,
    alterarCotacao: false,
    atualizarAutorizacao: false,
    contestacaoMedica: false,
    autorizada: false,
    autorizadaParcial: false,
    autorizadaAceitaMedico: false,
    voltarStatus: false,
    suprimentos: false,
    suprimentosCotacao: false,
    suprimentosAguardandoCotacao: false,
    equipamentos: false,
    reservaDeSala: false,
    alterarSolicitacao: false,
    buscarPaciente: false,
    editarProcedimentoPrincipal: false,
    editarProcedimentosAssociados: false,
    editarOpme: false,
    modalEditarFornecedorOPME: false,
    retornoDaAutorizacaoDoHis: false,
    editarEquipamento: false,
    cadastrarMaterial: false,
    cadastrarFornecedor: false,
    caixaCirurgica: false,
    alterarMaterial: false,
    fidelizacao: false,
    listaDeAnestesistas: false,
    orcamento: false,
    orcamentoParticular: false,
    gerarCobranca: false,
    informarPagamento: false,
    erroCoberturaVigente: false,
    regulacao: false,
    aguardandoNegociacaoParticular: false,
    pais: false,
    priorizar: false,
  }

  public procedimentoDefault: Procedimento = {
    procedimentoPrincipal: false,
    codigo: '',
    descricao: '',
    historicoMedico: false,
    id: '',
    procedimentoId: '',
    porte: '',
    quantidade: 1,
    lateralidade: '',
    temLateralidade: false,
    quantidadeAutorizada: 0,
    particular: false,
  }

  public disableCancelarSolicitacaoButton: boolean = false

  public protocoloOpmeMessageDefault: ProtocoloOpmeMessage = {
    protocoloOPMEMessage: '',
    protocoloOperadoraMessage: '',
  }

  public protocoloOpmeMessage: ProtocoloOpmeMessage = { ...this.protocoloOpmeMessageDefault }

  private acoesDefault: Acoes = {
    alterarData: false,
    analizarResposta: false,
    confirmarData: false,
    contatar: false,
    agendamentoRealizaTriagem: false,
    agendamentoAtualizaTriagem: false,
    visualizar: false,
    autorizacaoFazCotacao: false,
    autorizacaoAutorizar: false,
    autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
    autorizacaoFazAnalisePreAutorizacao: false,
    autorizacaoFazAnalisePreCotacao: false,
    agendamentoConfirmaCancelamento: false,
    autorizacaoAlteraSolicitacaoAutorizada: false,
    autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
    visualizarPendencia: false,
    agendamentoFazCancelamento: false,
    autorizacaoSolicitaCancelamento: false,
    anestesistaFazAvaliacao: false,
    autorizacaoAlteraCotacao: false,
    abrePendenciaAdministrativa: false, // This flag is not updated by api, use flag in solicitationFromList
    agendamentoResolvePendenciaAdministrativa: false, // This flag is not updated by api, use flag in solicitationFromList
  }

  public acoes: Acoes = { ...this.acoesDefault }
  private solicitacaoDefault: Solicitacao = {
    solicitacaoProcedimentoInternacao: {
      id: '',
      solicitacaoId: '',
      procedimentoInternacaoId: '',
      procedimentoInternacao: {
        id: '',
        codigo: '',
        descricao: '',
        tipo: '',
      },
      quantidade: 0,
      quantidadeAutorizada: 0,
    },
    temReservaHemocomponentesSimples: false,
    id: '',
    observacaoReservaSala: null,
    nomePaciente: '',
    hospitalId: '',
    dataNascimento: null,
    dataNascimentoTemp: '',
    telefone: '',
    celular: '',
    email: '',
    convenio: null,
    plano: null,
    carteirinha: '',
    diagnosticoJustificativa: '',
    resultadosDeExames: null,
    tempoCirurgia: null,
    opcaoDataPrevisto1: null,
    opcaoDataPrevisto2: null,
    opcaoDataPrevisto3: null,
    opcaoDataPrevisto1Temp: '',
    opcaoDataPrevisto2Temp: '',
    opcaoDataPrevisto3Temp: '',
    instrucaoData: null,
    dataAgendamentoVirtual: false,
    dataAgendamento: '',
    instrucaoDataPrevista: '',
    especificarPrecaucoes: '',
    alergiaLatexTemp: '',
    alergiaLatex: null,
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    especificarOutrasAlergias: null,
    carater: null,
    caraterTemp: null,
    files: [],
    laudos: [],
    resumos: [],
    cids: null,
    diaria: null,
    equipamentos: null,
    caixasCirurgicas: [],
    especificacaoExameIntraOperatorio: '',
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
    },
    honorarioMedico: null,
    honorarioMedicoTemp: null,
    honorarioMedicoDocumento: null,
    idade: null,
    lateralidade: null,
    medicoSolicitanteId: '',
    opmes: null,
    orientacaoPreparoPaciente: '',
    precaucoesTemp: null,
    precaucoes: null,
    procedimento: {
      codigo: '',
      descricao: '',
      historicoMedico: false,
      id: '',
      porte: '',
      procedimentoPrincipal: false,
      quantidade: 0,
      quantidadeAutorizada: 0,
      particular: false,
    },
    procedimentosAssociados: null,
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    },
    reservaUTI: {
      display: '',
      key: '',
    },
    reservaUtiTemp: null,
    anestesiaDoHospital: null,
    honorarioAnestesista: null,
    honorarioAnestesistaDocumento: null,
    anestesiaDoHospitalTemp: '',
    tipoProcedimento: null,
    tipoInternacao: null,
    lateralidadeTemp: null,
    tipoProcedimentoTemp: null,
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    medEspeciaisTemp: '',
    temPrevisaoUsoQuimioterapico: null,
    usoQuimioTemp: '',
    previsaoUsoQuimioterapico: null,
    recemNascido: null,
    recemNascidoTemp: null,
    sexo: '',
    statusSituacao: '',
    codigoPrestador: '',
    medicoSolicitante: {
      cpf: '',
      conselhoTipo: 'CRM',
      conselhoNumero: '',
      conselhoUf: '',
      email: '',
      especialidade: '',
      hospitais: [],
      id: '',
      medicoTemUsuario: false,
      nome: '',
      recebeEmailNotificacao: false,
      telefone: '',
      urlAssinatura: '',
    },
    secretariaDoMedicoSolicitante: {
      nome: '',
      telefone: '',
      email: '',
    },
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    numeroAgendamento: '',
    protocoloOPME: '',
    protocoloOperadora: '',
    autorizacaoValidade: '',
    dataAutorizacaoNaOperadora: '',
    autorizadoStatus: null,
    observacao: '',
    autorizacaoObservacao: '',
    situacao: {
      display: '',
      key: '',
    },
    acoes: {
      editar: false,
      podeResolverPendencia: false,
      aceitarAutorizacaoParcial: false,
      criarContestacao: false,
      responderContestacao: false,
      solicitarCancelamento: false,
      visualizarContestacao: false,
      visualizarItensAutorizados: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      agendamentoAtualizaTriagem: false,
      alterarData: false,
      analizarResposta: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      visualizar: false,
      visualizarPendencia: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePosCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoAutorizaNegociacaoParticular: false,
      agendamentoFazReservaDeSalaParticular: false,
      agendamentoInformaReservaEmSolicitacaoParticular: false,
      exibeGuiasDePrestadorOperadora: false,
    },
    cotacaoOperadorasExtraGrupo: {
      faturamentoDiretoComOperadora: false,
      comentarios: '',
      notaFiscal: false,
      observacao: 'Outros',
      valor: null,
      cotacaoComUrgencia: false,
      dataReferenciaParaOperadora: '',
    },
    hospitalRealizaCotacao: null,
    elegivel: null,
    dataVerificacaoElegibilidade: null,
    erroVerificacaoElegibilidade: null,
    observacaoPreAnestesia: '',
    outrasAlergias: null,
    tipoAnestesia: '',
    tipoAnestesiaPaciente: '',
    viasAereasDificilAcesso: null,
    preAnestesico: null,
    statusAvaliacaoPreAnestesia: {
      display: '',
      key: '',
    },
    pacienteAptoParaAnestesia: null,
    cnpjDoHospital: '',
    medicoAnestesistaPreAvaliacaoNome: '',
    tipoAnestesiaTemp: null,
    origem: null,
    enviadaPor: null,
    outrosTipoAnestesia: null,
    pacienteUsaMarcaPasso: null,
    auditada: false,
    auditadaObservacao: '',
    salaCirurgicaNome: '',
    opmeFornecedores: [],
    statusAguardandoOperadora: '',
    negociacaoParticularStatus: null,
    numeroOrcamento: null,
    etapa: {
      display: '',
      key: '',
    },
    localAtendimentoId: null,
    localAtendimentoNome: '',
    grupoOpmeDaSolicitacao: [],
    cpf: '',
    paciente: {
      carteirinha: '',
      celular: '',
      convenioId: '',
      convenioNome: '',
      planoId: '',
      planoNome: '',
      categoriaId: '',
      categoriaNome: '',
      categoriaCoberturaVigente: undefined,
      tipoAcomodacao: '',
      cpf: '',
      rgh: '',
      cpfResponsavel: '',
      rne: null,
      passaporte: null,
      paisId: null,
      certidaoNascimentoLivro: '',
      certidaoNascimentoFolha: '',
      certidaoNascimentoTermo: '',
      nomeSocial: '',
      dataNascimento: '',
      dataVerificacaoElegibilidade: '',
      elegivel: '',
      email: '',
      id: '',
      idade: '',
      nome: '',
      recemNascido: '',
      sexo: '',
      telefone: '',
      peso: '',
      altura: '',
    },
    pacienteNome: '',
    historicoFamiliarHipertemiaMaligna: null,
    classificacaoAsa: null,
    observacaoComplementares: null,
    hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: false,
    diferencaDeAcomodacao: null,
    temEquipeMedica: '',
    temOpmeDoConsultorio: null,
    temInstrumentadorExterno: '',
    equipeMedica: '',
    opmeDoConsultorio: '',
    instrumentadorExterno: '',
    diariaUti: null,
    temInternacaoDeVespera: '',
    internacaoDeVespera: '',
    canceladoMotivo: {
      display: '',
      key: '',
    },
    pesoDoPaciente: null,
    tempoDeDoenca: null,
    farmacia: null,
    hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos: false,
    hospitalRealizaTriagemDuranteOPreAgendamento: false,
    operadoraSenha: '',
    operadoraQuantidadeDiasAutorizado: null,
    operadoraSenhaProvisoria: '',
    convenioParticular: null,
    procedimentosInternacao: [],
    hospitalInsereProcedimentosDeInternacao: false,
    outrasSolicitacoesNaoRealizadasDoPaciente: [],
    convenioUtilizaRoboDeAutorizacao: false,
    roboAutorizacaoMotivoNegativa: null,
    roboAutorizacaoStatusDaAutorizacao: null,
    temOpme: false,
    autorizacaoDeveInformarProtocoloDaOperadora: false,
    convenioExigeCodificacaoOpme: false,
    configuracaoOpme: {
      codificacaoDeOpmeEhObrigatorio: false,
      fazCodificacaoDeOpme: false,
      precificaValorUnitario: false,
      precificacaoValorUnitarioEhObrigatorio: false,
    },
    hospitalEConvenioUtilizamRoboDeAutorizacao: false,
    temConsultaDePrecaucoesDoPaciente: false,
    materiaisCotadosOpme: null,
    utilizaAutorizacaoPos: false,
    dataAutorizacaoNaOperadoraObrigatoria: false,
    registraProtocoloDeRecuperacaoPrecoce: null,
    comorbidadesDoPaciente: [],
    classificacaoCirurgia: null,
    numeroDoAtendimentoAoPacienteNoHospital: '',
    justificativaTecnica: '',
    horasDeAntecedenciaDeInternacao: null,
    dataAntecedenciaDeInternacao: '',
    lesoes: [],
    bloquearIntegracaoAutorizador: false,
    categoriaEscolhidaAPartirDoConvenio: false,
    dadosGestacionais: {
      idadeGestacional: null,
      gemelar: null,
    },
  }

  public solicitacao: Solicitacao = { ...this.solicitacaoDefault }

  private reservaHemocomponentesDefault: ReservaHemocomponente = {
    concentradoHemacias: {
      quantidade: 0,
      value: false,
    },
    concentradoPlaquetas: {
      quantidade: 0,
      value: false,
    },
    crioprecipitado: {
      quantidade: 0,
      value: false,
    },
    plasmaFrescoCongelado: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguineaABORHPAI: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguinea: {
      value: false,
      quantidade: 0,
    },
    semReserva: {
      value: false,
      quantidade: 0,
    },
  }

  public reservaHemocomponentes: ReservaHemocomponente = { ...this.reservaHemocomponentesDefault }

  private novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }

  private agendamentoConfirmarTriagemDefault: AgendamentoTriagemConfirmar = {
    dataAgendamentoVirtual: false,
    numeroAgendamento: '',
    solicitacaoId: '',
    dataAgendamento: '',
  }

  private cotacaoOperadorasExtraGrupoDefault = {
    faturamentoDiretoComOperadora: false,
    comentarios: '',
    notaFiscal: false,
    observacao: 'Outros',
    valor: null,
    cotacaoComUrgencia: false,
    dataReferenciaParaOperadora: '',
  }

  private contestacaoMedicaDefault: ContestacaoMedica = {
    nomePaciente: '',
    medicoSolicitanteNome: '',
    protocoloOperadora: '',
    protocoloOPME: '',
    autorizacaoValidade: '',
    dataAutorizacaoNaOperadora: '',
    autorizacaoObservacao: '',
    contestacaoId: '',
    mensagens: [],
  }

  public agendamentoConfirmarTriagem: AgendamentoTriagemConfirmar = { ...this.agendamentoConfirmarTriagemDefault }
  public tipoEnvioMensagem: string = ''
  public contestacaoMedica: ContestacaoMedica = { ...this.contestacaoMedicaDefault }

  private triagem: Triagem.ITriagem = new Triagem.Triagem()
  private agendamento: Agendamento.IAgendamento = new Agendamento.Agendamento()
  private autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  private preAnestesia: PreAnestesia.IPreAnestesia = new PreAnestesia.PreAnestesia()
  private suprimentos: Suprimentos.ISuprimentos = new Suprimentos.Suprimentos()
  private solicitacaoCirurgiaImp: SolicitacaoCirurgiaImp.ISolicitacaoCirurgiaImp = new SolicitacaoCirurgiaImp.SolicitacaoCirurgiaImp()

  public agendamentoMedicoId: string = ''
  public adicionaPaciente: boolean = true
  public atualizaPaciente: boolean = false
  public equipamentos: Equipamento[] = []
  public equipamentosSugeridos: Equipamento[] = []
  public equipamentoGruposDaSolicitacao: EquipamentoGrupoDaSolicitacao[] = []
  public equipamentosApi: Equipamento[] = []
  public equipamentoGruposApi: EquipamentoGrupo[] = []
  public pendingAutoSelectedEquipamentos: EquipamentoGrupoChild[] = []
  public template: any = { formulario: {}, hospital: {}, porConvenio: [] }
  public grupoOpmeApi: any = []
  public healthInsuranceData: Convenio = {
    id: '',
    nome: '',
    particular: false,
    status: '',
    convenioUtilizaFluxoDePreviaCirurgica: false,
    prazoEmDiasParaTriagem: 0,
    prazoMaximoEmDiasParaAgendamento: 0,
  }

  public hospitais: Hospital[] = []
  public convenios: Convenio[] = []
  public planos: Plano[] = []
  public categorias: any[] = []
  private solicitacaoAlteradaDefault: any = {
    solicitacaoId: null,
    medicoSolicitanteId: null,
    hospitalId: null,
    hospital: {
      hospitalValidaHisIdDoFornecedorOpme: false,
    },
    paciente: {
      pacienteId: null,
      convenioId: null,
      planoId: null,
      categoriaId: null,
      carteirinha: null,
    },
    carater: null,
    tipoAcomodacao: null,
    hospitalTipoAcomodacao: undefined,
    procedimento: null,
    procedimentosAssociados: [],
    grupoOpmeDaSolicitacao: [],
    grupoDeOpme: {
      opmes: [],
    },
    equipamentos: [],
    classificacaoCirurgia: null,
    honorarioMedico: '',
    honorarioMedicoDocumento: null,
    codigoPrestador: '',
    equipeMedica: '',
    temEquipeMedica: null,
    equipeCirurgica: [],
    honorarioAnestesistaEnum: '',
    honorarioAnestesistaDocumento: null,
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: 0,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: 0,
        value: false,
      },
      crioprecipitado: {
        quantidade: 0,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: 0,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: 0,
        value: false,
      },
      semReserva: {
        quantidade: 0,
        value: false,
      },
    },
    temReservaHemocomponentesSimples: null,
    solicitacaoProcedimentoInternacao: {
      id: '',
      solicitacaoId: '',
      procedimentoInternacaoId: '',
      procedimentoInternacao: {
        id: '',
        codigo: '',
        descricao: '',
        tipo: '',
      },
      quantidade: 0,
      quantidadeAutorizada: 0,
    },
    pacienteEhOncologico: null,
    tipoProcedimento: null,
  }

  private embeddedInfoDefault = {
    id: '',
    url: '',
    token: '',
  }

  private tempoDeDoencaDefault: TempoDeDoenca = {
    anos: 0,
    meses: 0,
    dias: 0,
  }

  private pacienteDefault: Paciente = {
    carteirinha: '',
    celular: '',
    convenioId: '',
    planoId: '',
    cpf: '',
    rgh: '',
    peso: null,
    altura: null,
    cpfResponsavel: '',
    rne: null,
    passaporte: null,
    paisId: null,
    certidaoNascimentoLivro: '',
    certidaoNascimentoFolha: '',
    certidaoNascimentoTermo: '',
    nomeSocial: '',
    dataNascimento: '',
    id: '',
    idade: null,
    nome: '',
    nomeMae: '',
    pacienteNaoPossuiCpf: false,
    sexo: '',
    telefone: '',
    categoriaId: '',
    hisId: '',
  }

  private solicitacaoCirurgiaDefault: SolicitacaoCirurgia = {
    id: '',
    modeloCirurgiaId: '',
    hospitalId: '',
    medicoPrescritor: {
      crm: '',
      email: '',
      id: '',
      nome: '',
      especialidade: '',
    },
    medicoSolicitante: {
      conselhoTipo: 'CRM',
      conselhoNumero: '',
      conselhoUf: '',
      email: '',
      id: '',
      nome: '',
      urlAssinatura: '',
    },
    medicoSolicitanteId: '',
    hospital: {
      id: '',
      nome: '',
      urlAssinatura: '',
      usaProcedimentosApenasHospitalDia: false,
      hospitalExigeDocumentacaoDoPacienteQuandoCaraterUrgencia: false,
      hospitalIntegraComAutorizadorAntesDaReserva: false,
      hospitalConfiguraDataSugeridaEmDiasUteis: false,
    },
    localAtendimentoId: null,
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoBACCHI: false,
      congelacaoFilomenaMarinhoCarvalho: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
      culturaSonicacao: false,
      anestesiaAMD: false,
      exameEcoIntraoperatorio: false,
      exameUsgIntraoperatorio: false,
      gdlReservaDeUtiAdulto: false,
      gdlReservaDeUtiPediatrica: false,
      gdlUiHemoAngio: false,
      laboratorioPthRapido: false,
      servicoAnextesia: false,
      laboratorioBacchi: false,
      laboratorioFilomenaMarinoCarvalho: false,
      laboratorioPathosDiagnosticosMedicos: false,
      laboratorioLocus: false,
      laboratorioFleury: false,
      anestesiaGaap: false,
      broncoscopista: false,
      exameMamografia: false,
      exameRxIntraoperatorio: false,
      reservaDeRoll: false,
      laboratorioCongelacaoServicoInterno: false,
      laboratorioCongelacaoServicoExternoParticular: false,
      gdlRetaguardaUtiAdulto: false,
      gdlRetaguardaUtiPediatrica: false,
      laboratorioFleuryAnalisesClinicas: false,
      exameEcoIntraoperatorioSemProfissional: false,
      exameUltrassomIntraoperatorioComProfissional: false,
      exameTomografiaIntraoperatorio: false,
      exameEndoscopiaIntraoperatoriaComProfissional: false,
      exameEndoscopiaIntraoperatoriaSemProfissional: false,
      exameBroncoscopiaIntraoperatoriaComProfissional: false,
      exameBroncoscopiaIntraoperatoriaSemProfissional: false,
      exameEcoIntraoperatorioComProfissional: false,
    },
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: 0,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: 0,
        value: false,
      },
      crioprecipitado: {
        quantidade: 0,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: 0,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: 0,
        value: false,
      },
      semReserva: {
        quantidade: 0,
        value: false,
      },
    },
    diagnosticoJustificativa: '',
    alergiaLatex: '',
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    precaucoes: '',
    carater: '',
    reservaUTI: '',
    diaria: null,
    instrucaoDataPrevista: '',
    honorarioMedico: '',
    honorarioMedicoDocumento: null,
    codigoPrestador: '',
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    temPrevisaoUsoQuimioterapico: null,
    previsaoUsoQuimioterapico: '',
    anestesiaDoHospital: '',
    honorarioAnestesista: '',
    honorarioAnestesistaDocumento: '',
    solicitacaoMedicoConvidado: {
      medicoConvidado: '',
      celular: '',
      codigoConselho: '',
      nome: '',
    },
    nome: '',
    paciente: {
      carteirinha: '',
      celular: '',
      convenioId: '',
      planoId: '',
      cpf: '',
      rgh: '',
      peso: null,
      altura: null,
      cpfResponsavel: '',
      rne: null,
      passaporte: null,
      paisId: null,
      certidaoNascimentoLivro: '',
      certidaoNascimentoFolha: '',
      certidaoNascimentoTermo: '',
      nomeSocial: '',
      dataNascimento: '',
      id: '',
      idade: null,
      nome: '',
      nomeMae: '',
      pacienteNaoPossuiCpf: false,
      sexo: '',
      telefone: '',
      categoriaId: '',
      hisId: '',
    },
    comorbidadesDoPaciente: [],
    historicoDeCardiopatiaHisquemicaEspecificar: null,
    historicoDeInsuficienciaCardiacaEspecificar: null,
    historicoDeDoencaVascularCerebralEspecificar: null,
    diabetesEspecificar: null,
    obesidadeEspecificar: null,
    arritimiaCardiacaPorFibrilacaoAuricularEspecificar: null,
    pacientePossuiLiberacaDoClinicoOuCardiologistaEspecificar: null,
    especificarPrecaucoes: '',
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    temSolicitacaoReservaDeSangue: '',
    instrumentalAdicional: '',
    tempoCirurgia: 0,
    dataAgendamentoVirtual: null,
    diferencaDeAcomodacao: null,
    temEquipeMedica: null,
    temInstrumentadorExterno: null,
    equipeCirurgica: [],
    equipeMedica: '',
    instrumentadorExterno: '',
    diariaUti: null,
    tipoAcomodacao: null,
    hospitalTipoAcomodacaoId: null,
    tecnicaDaCirurgia: null,
    temInternacaoDeVespera: null,
    internacaoDeVespera: '',
    temReservaHemocomponentesSimples: null,
    pesoDoPaciente: null,
    tempoDeDoenca: { ...this.tempoDeDoencaDefault },
    farmacia: null,
    tipoProcedimento: null,
    tipoInternacao: null,
    criadaComoPreReserva: false,
    configuracoes: {
      paciente: {
        celular: true,
        cpf: true,
        tipoPaciente: true,
        rne: true,
        passaporte: true,
        paisId: true,
        cpfResponsavel: true,
        certidaoNascimentoLivro: true,
        certidaoNascimentoFolha: true,
        certidaoNascimentoTermo: true,
        nomeSocial: true,
        dataNascimento: true,
        nome: true,
        nomeMae: true,
        sexo: true,
        telefone: true,
        carteirinha: true,
        convenioId: true,
        planoId: true,
        pacienteNaoPossuiCpf: true,
        idade: true,
        categoriaId: true,
      },
      prazoEmDiasParaTriagem: 0,
      prazoMaximoEmDiasParaAgendamento: 0,
    },
    caixasCirurgicas: [],
    numeroDoAtendimentoAoPacienteNoHospital: '',
    justificativaTecnica: '',
    acoes: {
      podeEditarFormularioDaAutorizacao: false,
      podeFinalizarSolicitacao: false,
      medicoPodeEnviarParaOAutorizador: false,
      permiteSugerirProtocoloAoCarregarSolicitacao: true,
      verificaLimitadorDeCirurgia: false,
      permiteEditarAlergiaLatex: true,
      permiteEditarPrecaucoes: true,
    },
    solicitacaoProcedimentoInternacao: {
      id: '',
      solicitacaoId: '',
      procedimentoInternacaoId: '',
      procedimentoInternacao: {
        id: '',
        codigo: '',
        descricao: '',
        tipo: '',
      },
      quantidade: 0,
      quantidadeAutorizada: 0,
    },
    dadosGestacionais: {
      idadeGestacional: null,
      gemelar: null,
    },
  }

  private procedimentoInternacaoOperadoraDefault: ProcedimentoInternacaoOperadora = {
    procedimentoId: '',
    quantidade: 0,
  }

  public embeddedInfo = { ...this.embeddedInfoDefault }


  private procedimentosInternacaoDefault: Procedimento[] = []
  private pacientesListaDefault: Paciente[] = []

  public solicitacaoAlterada: any = { ...this.solicitacaoAlteradaDefault }
  public procedimentosInternacao: Procedimento[] = [...this.procedimentosInternacaoDefault]
  public procedimentosInternacaoSelected: Procedimento[] = []
  public pacientesLista: Paciente[] = [...this.pacientesListaDefault]
  public solicitacaoCirurgia: SolicitacaoCirurgia = { ...this.solicitacaoCirurgiaDefault }
  public hospitalId: string = ''
  public mapaCirurgicoAlterarReserva: boolean = false
  public mapaCirurgicoGradeAlterarReserva: boolean = false
  public desfazCancelamento: boolean = false
  public equipmentSelectionConfirmed: boolean = false
  public executantDoctorModal: boolean = false
  public doctors = []
  public powerBiReportTypes: PowerBiReportType[] = []
  public hospitalsCurrentUser: { id: string, nome: string }[] = []
  public hospitalsSurgeryCenters: { id: string, nome: string }[] = []

  public powerBiReport: PowerBiReportType[] = []
  public lastSelectedEquipmentsBeforeHospitalChange: string[] = []
  public procedimentoInternacaoOperadora: ProcedimentoInternacaoOperadora = { ...this.procedimentoInternacaoOperadoraDefault }
  public valorNegociadoLoading: boolean = false

  private medicoDoHisDefault: MedicoDoHis = {
    hisId: '',
    nome: '',
    cpf: '',
    crm: '',
    dataDesligamento: '',
  }

  public medicoDoHis: MedicoDoHis = { ...this.medicoDoHisDefault }

  @Mutation
  setMedicoDoHis(value: MedicoDoHis) {
    this.medicoDoHis = value
  }

  @Mutation
  setEquipmentSelectionConfirmation(confirmed: boolean) {
    this.equipmentSelectionConfirmed = confirmed
  }

  @Mutation
  clearMedicoDoHis() {
    this.medicoDoHis = { ...this.medicoDoHisDefault }
  }

  @Mutation
  setValorNegociadoLoading(value: boolean) {
    this.valorNegociadoLoading = value
  }

  public outroAnestesista: string = ''

  @Mutation
  setOutroAnestesista(value: string) {
    this.outroAnestesista = value
  }

  public clinicasDeAnestesia: {hospitalId: string, data: AnestesistaHospital[]} = { hospitalId: '', data: [] }

  @Mutation
  setClinicasDeAnestesia({ hospitalId, data }: {hospitalId: string, data: AnestesistaHospital[]}) {
    this.clinicasDeAnestesia = { hospitalId, data }
  }

  @Mutation
  clearClinicasDeAnestesia() {
    this.clinicasDeAnestesia = { hospitalId: '', data: [] }
  }

  @Action
  async getClinicasDeAnestesia({
    hospitalId,
    qtdPorPagina = 5,
    searchText = '',
    tipo = 'clinica',
    forceRefresh = false,
  }: {hospitalId: string, qtdPorPagina?: number, searchText?: string, tipo?: string, forceRefresh?: boolean}) {
    if (hospitalId === this.clinicasDeAnestesia.hospitalId && !forceRefresh) return this.clinicasDeAnestesia.data
    const loadAnestesistaPayload = {
      qtdPorPagina,
      searchText,
      tipo,
      hospitalId,
    }
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllAnestesistas(loadAnestesistaPayload)
    if (request.success) {
      this.context.commit('setClinicasDeAnestesia', { hospitalId, data: request.data.anestesistas })
      return request.data.anestesistas
    }
    this.context.commit('clearClinicasDeAnestesia')
    return []
  }

  get segueOProtocoloStatus() {
    return this.solicitacao.protocoloDeCirurgia && this.solicitacao.protocoloDeCirurgia.segueOProtocolo
  }

  get canShowManualSyncronizationHisAlert() {
    return this.solicitacao.naoSeraSincronizadaNoHisPorqueFoiCriadaAntesDoGoLive
  }

  get componentToConfirmReservation() {
    // Room reservation in his
    if (
      this.solicitacao.hospitalFazReservaDeSala
    ) {
      return 'BackofficeConfirmarReservaSala'
    }

    // Default component that not use his reservation
    return 'BackofficeConfirmarTriagem'
  }

  @Mutation
  clearSolicitacaoAlteradaInstrumentadorExternoEspecificar() {
    this.solicitacaoAlterada.instrumentadorExterno = ''
  }

  @Mutation
  clearSolicitacaoAlteradaEquipamentos() {
    this.solicitacaoAlterada.equipamentos = []
  }

  @Mutation
  setMapaCirurgicoAlterarReserva(value: boolean) {
    this.mapaCirurgicoAlterarReserva = value
  }

  @Mutation
  setmapaCirurgicoGradeAlterarReserva(value: boolean) {
    this.mapaCirurgicoGradeAlterarReserva = value
  }

  @Mutation
  setBackofficeArea(value: string) {
    this.backofficeArea = value
  }

  @Mutation
  setShowModalCadastrarMaterial(value: boolean) {
    this.modal.cadastrarMaterial = value
  }

  @Mutation
  setShowModalCadastrarFornecedor(value: boolean) {
    this.modal.cadastrarFornecedor = value
  }

  @Mutation
  setShowModalBuscarPaciente(value: boolean) {
    this.modal.buscarPaciente = value
  }

  @Mutation
  setPacientesLista(value: Paciente[]) {
    this.pacientesLista = value
  }

  @Mutation
  clearPacientesLista() {
    this.pacientesLista = [...this.pacientesListaDefault]
  }

  @Mutation
  setConsultaPacienteNome(paciente: Paciente) {
    if (paciente) {
      Object.entries(paciente).forEach(([key, value]) => {
        switch (key) {
          case 'dataNascimento':
            this.solicitacaoCirurgia.paciente[key] = moment(value).format('YYYY-MM-DD')
            break
          case 'celular':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          case 'telefone':
            this.solicitacaoCirurgia.paciente[key] = flatPhone(value)
            break
          default:
            this.solicitacaoCirurgia.paciente[key] = value
            break
        }
      })
    } else {
      const { cpf } = this.solicitacaoCirurgia.paciente
      this.solicitacaoCirurgia.paciente = { ...this.pacienteDefault }
      this.solicitacaoCirurgia.paciente.cpf = cpf
    }
  }

  get procedimentoPrincipal() {
    return this.solicitacaoAlterada.procedimento
  }

  get procedimentosAssociados() {
    return this.solicitacaoAlterada.procedimentosAssociados
  }

  private procedimentosApiDefault: Procedimento[] = []
  public procedimentosApi: Procedimento[] = [...this.procedimentosApiDefault]

  public modalSolicitacaoCirurgia: ModalSolicitacaoCirurgia = {
    showCid: false,
    showProcedimentoPrincipal: false,
    showProcedimentoAssociado: false,
    showAssociadoQuantidade: false,
    showQuantidade: false,
    showOpme: false,
    showOpmeFornecedor: false,
    showProtocoloFornecedor: false,
    showEquipamento: false,
    showTecnicaRobotica: false,
    showHospitalOpcoes: false,
    showItensAutorizados: false,
    showItensAutorizadosClinica: false,
    showMotivoCancelamento: false,
    showSair: false,
    showGerenciar: false,
    showAlteracaoDataSolicitada: false,
    showAlteracaoDataSolicitadaClinica: false,
    showModalPendenciaProtocolo: false,
  }

  @Mutation
  setComentarios(value: string) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.comentarios = value
  }

  @Mutation
  clearComentarios() {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.comentarios = ''
  }

  @Mutation
  setProcedimentosInternacao(value: Procedimento[]) {
    this.procedimentosInternacao = value
  }

  @Mutation
  setProcedimentosInternacaoSelected(value: Procedimento[]) {
    this.procedimentosInternacaoSelected = value
  }

  @Mutation
  addProcedimentosInternacaoSelected(value: Procedimento) {
    this.procedimentosInternacaoSelected.push(value)
    const index = this.procedimentosInternacao.findIndex((e: any) => e.id === value.id)
    this.procedimentosInternacao.splice(index, 1)
  }

  @Mutation
  removeProcedimentosInternacaoSelected(id: string) {
    const index = this.procedimentosInternacaoSelected.findIndex((e: any) => e.id === id)
    this.procedimentosInternacaoSelected.splice(index, 1)
  }

  @Mutation
  clearProcedimentosInternacao() {
    this.procedimentosInternacao = [...this.procedimentosInternacaoDefault]
  }

  @Mutation
  setGrupoOpmeApi(value: any) {
    this.grupoOpmeApi = value
  }

  @Mutation
  setNumeroAgendamento(numero: string) {
    this.solicitacao.numeroAgendamento = numero
  }

  @Mutation
  setConvenios(convenios: Convenio[]) {
    this.convenios = convenios
  }

  @Mutation
  setPlanos(planos: Plano[]) {
    this.planos = planos
  }

  @Mutation
  setCategorias(categorias: any[]) {
    this.categorias = categorias
  }

  @Mutation
  clearConvenios() {
    this.convenios = []
    this.solicitacaoAlterada.paciente.convenioId = ''
    this.solicitacaoAlterada.paciente.planoId = ''
    this.solicitacaoAlterada.paciente.categoriaId = ''
  }

  @Mutation
  clearPlanos() {
    this.planos = []
    this.solicitacaoAlterada.paciente.planoId = ''
    this.solicitacaoAlterada.paciente.categoriaId = ''
  }

  @Mutation
  clearCategorias() {
    this.categorias = []
  }

  @Mutation
  setEmbeddedInfo(info: any) {
    this.embeddedInfo = info
  }

  @Mutation
  setSolicitacaoAlterada(solicitacao: any) {
    this.solicitacaoAlterada = {
      ...cloneDeep(this.solicitacaoAlteradaDefault),
      solicitacaoProcedimentoInternacao: {
        ...this.solicitacaoAlteradaDefault.solicitacaoProcedimentoInternacao,
      },
      ...solicitacao,
    }
    this.solicitacaoAlterada.dadosGestacionais = {
      ...this.solicitacaoAlteradaDefault.dadosGestacionais,
      ...(solicitacao.dadosGestacionais || {}),
    }
    this.solicitacaoAlterada.hospital = solicitacao.hospital
    this.solicitacaoAlterada.anestesiaDoHospital = solicitacao.anestesiaDoHospital
    this.solicitacaoAlterada.anestesista = solicitacao.anestesista
    this.solicitacaoAlterada.nomeAnestesista = solicitacao.nomeAnestesista
    this.solicitacaoAlterada.solicitacaoId = solicitacao.id || solicitacao.solicitacaoId
    this.solicitacaoAlterada.medicoSolicitanteId = solicitacao.medicoSolicitanteId
    this.solicitacaoAlterada.procedimento = solicitacao.procedimento
    this.solicitacaoAlterada.procedimentosAssociados = solicitacao.procedimentosAssociados
    this.solicitacaoAlterada.procedimentosInternacao = solicitacao.procedimentosInternacao
    this.solicitacaoAlterada.grupoOpmeDaSolicitacao = solicitacao.grupoOpmeDaSolicitacao || []
    this.solicitacaoAlterada.hospitalId = solicitacao.hospitalId
    this.solicitacaoAlterada.paciente.convenioId = solicitacao.paciente.convenioId
    this.solicitacaoAlterada.paciente.pacienteId = solicitacao.paciente.id || solicitacao.paciente.pacienteId
    this.solicitacaoAlterada.paciente.planoId = solicitacao.paciente.planoId || null
    this.solicitacaoAlterada.paciente.categoriaId = solicitacao.paciente.categoriaId || null
    this.solicitacaoAlterada.paciente.carteirinha = solicitacao.paciente.carteirinha || null

    if (solicitacao.hospital.utilizaTipoAcomodacaoHospital) {
      this.solicitacaoAlterada.hospitalTipoAcomodacaoId = solicitacao.hospitalTipoAcomodacao ? solicitacao.hospitalTipoAcomodacao.id : null
      delete this.solicitacaoAlterada.tipoAcomodacao
    } else {
      this.solicitacaoAlterada.tipoAcomodacao = solicitacao.tipoAcomodacao ? solicitacao.tipoAcomodacao.key || solicitacao.tipoAcomodacao : null
      delete this.solicitacaoAlterada.hospitalTipoAcomodacaoId
      delete this.solicitacaoAlterada.hospitalTipoAcomodacao
    }

    this.solicitacaoAlterada.carater = solicitacao.carater.key
    this.solicitacaoAlterada.honorarioMedico = solicitacao.honorarioMedico && solicitacao.honorarioMedico.key ? solicitacao.honorarioMedico.key : ''
    this.solicitacaoAlterada.classificacaoCirurgia = solicitacao.classificacaoCirurgia
    this.solicitacaoAlterada.etapa = solicitacao.etapa
    this.solicitacaoAlterada.observacaoReservaSala = solicitacao.observacaoReservaSala
    this.solicitacaoAlterada.equipamentos = solicitacao.equipamentos
    this.solicitacaoAlterada.protocoloDeCirurgia = solicitacao.protocoloDeCirurgia || null
    this.solicitacaoAlterada.tipoInternacao = solicitacao.tipoInternacao ? solicitacao.tipoInternacao.key || solicitacao.tipoInternacao : null
    this.solicitacaoAlterada.tipoProcedimento = solicitacao.tipoProcedimento ? solicitacao.tipoProcedimento.key || solicitacao.tipoProcedimento : null
    this.solicitacaoAlterada.diaria = ['', null, undefined, 0].includes(solicitacao.diaria) ? null : solicitacao.diaria
    this.solicitacaoAlterada.reservaUTI = solicitacao.reservaUTI ? solicitacao.reservaUTI.key || solicitacao.reservaUTI : null
    this.solicitacaoAlterada.diariaUti = ['', null, undefined, 0].includes(solicitacao.diariaUti) ? null : solicitacao.diariaUti

    const reservaHemocomponentesFromApi = solicitacao.reservaHemocomponentes.reduce((prev, curr) => {
      Object.assign(prev, { [formatHemocomponenteName(curr.key)]: { quantidade: curr.quantidade, value: true } })
      return prev
    }, {})

    this.solicitacaoAlterada.reservaHemocomponentes = {
      concentradoHemacias: {
        quantidade: 0,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: 0,
        value: false,
      },
      crioprecipitado: {
        quantidade: 0,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: 0,
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: 0,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
        quantidade: 0,
      },
      semReserva: {
        value: false,
        quantidade: 0,
      },
      ...reservaHemocomponentesFromApi,
    }

    const reservaHemocomponentesKeys = Object.keys(this.solicitacaoAlterada.reservaHemocomponentes).filter((key: string) => this.solicitacaoAlterada.reservaHemocomponentes[key].value)
    if (reservaHemocomponentesKeys.length > 0) this.hemocomponentesCheckbox = reservaHemocomponentesKeys

    const grupoOpmeDaSolicitacaoJson = JSON.stringify(this.solicitacaoAlterada.grupoOpmeDaSolicitacao)
    this.grupoOpmeDaSolicitacao = JSON.parse(grupoOpmeDaSolicitacaoJson)

    // Cria grupoDeOpme a partir de grupoOpmeDaSolicitacao
    if (!solicitacao.grupoDeOpme) {
      const mappedOpmes: SolicitacaoOpme[] = []
      this.grupoOpmeDaSolicitacao.forEach((grupoOpme) => {
        grupoOpme.opmes.forEach((opme) => {
          const {
            quantidade, gradeCompleta, observacao, fornecedor1Id, fornecedor2Id, fornecedor3Id, particular, medidaTamanho,
            fornecedor1, fornecedor2, fornecedor3,
          } = opme

          const newOpme: {
            id: string;
            descricao: string;
            quantidade: number;
            particular?: boolean;
            medidaTamanho?: string;
            gradeCompleta: boolean;
            observacao: string | undefined;
            fornecedor1Id: string | undefined;
            fornecedor2Id: string | null | undefined;
            fornecedor3Id: string | null | undefined;
            fornecedor1?: any;
            fornecedor2?: any;
            fornecedor3?: any;
          } = {
            id: opme.opmeId,
            descricao: opme.opme.descricao,
            quantidade,
            gradeCompleta,
            observacao,
            fornecedor1Id,
            fornecedor2Id,
            fornecedor3Id,
            fornecedor1,
            fornecedor2,
            fornecedor3,
          }

          if (particular) {
            newOpme.particular = particular
          }

          if (medidaTamanho) {
            newOpme.medidaTamanho = medidaTamanho
          }

          mappedOpmes.push(newOpme as any)
        })
      })

      this.solicitacaoAlterada.grupoDeOpme = { opmes: mappedOpmes }
    }

    // Esse trecho converte o formato dos exames intraoperatórios
    // em um formato compatível com o formuláio de exames intraoperatórios
    // e esperado pelo endpoint de atualização do orçamento.
    //
    // Para isso:
    // - Normaliza o case da chave do exame (ex.: "Biopsia" → "biopsia")
    // - Mapeia as propriedades adicionais de um exame quando presente.
    //   Exemplo:
    //   { key: "AnatomiaPatologica", ..., particularLocal: "Particular" }
    //   deve mapear para
    //   { anatomiaPatologica: true, anatomiaPatologicaHospitalOuParticular: "Particular" }
    // - Considera o caso especial do exame "PTH", que tem a chave com todas as
    //   letras em maíusculo e por isso falha na normalização do case.

    const examesIntraOperatorios: Record<string, boolean | string | null> = {}

    this.solicitacaoAlterada.examesIntraOperatorios.forEach((item) => {
      if (item.key === 'PTH') {
        examesIntraOperatorios.pth = true
        return
      }

      const keyBase = item.key.charAt(0).toLowerCase() + item.key.slice(1)

      examesIntraOperatorios[keyBase] = true

      if (item.key === 'AnatomiaPatologica' && item.hospitalOuParticular) {
        examesIntraOperatorios.anatomiaPatologicaHospitalOuParticular = item.hospitalOuParticular
      }

      if (item.key === 'AnatomiaPatologica' && item.particularLocal) {
        examesIntraOperatorios.anatomiaPatologicaParticularLocal = item.particularLocal
      }

      if (item.key === 'Biopsia' && item.hospitalOuParticular) {
        examesIntraOperatorios.biopsiaHospitalOuParticular = item.hospitalOuParticular
      }

      if (item.key === 'Biopsia' && item.particularLocal) {
        examesIntraOperatorios.biopsiaParticularLocal = item.particularLocal
      }

      if (item.key === 'UltrassonografiaIntraoperatoria' && item.equipeDoHospital !== undefined) {
        examesIntraOperatorios.ultrassonografiaIntraoperatoriaEquipeDoHospital = item.equipeDoHospital
      }

      if (item.key === 'Outros' && item.outrosEspecificar) {
        examesIntraOperatorios.outrosEspecificar = item.outrosEspecificar
      }
    })

    this.solicitacaoAlterada.examesIntraOperatorios = examesIntraOperatorios
  }

  @Mutation
  setSolicitacaoFields({ field, value }) {
    this.solicitacao[field] = value
  }

  @Mutation
  setSolicitacaoAlteradaFields({ field, value }) {
    this.solicitacaoAlterada[field] = value
  }

  @Mutation
  adjustSolicitacaoTOHospitalDiaRules() {
    if (opcaoHabilitadoShared(this.template, 'tipoProcedimento', 'hospitalDia')) this.solicitacaoAlterada.tipoProcedimento = 'HospitalDia'
    if (campoHabilitadoShared(this.template, 'diaria')) this.solicitacaoAlterada.diaria = 1
    if (campoHabilitadoShared(this.template, 'reservaUti') && opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')) this.solicitacaoAlterada.reservaUTI = 'SemReserva'
    if (campoHabilitadoShared(this.template, 'reservaUti') && opcaoHabilitadoShared(this.template, 'reservaUti', 'reservaUtiNao')) this.solicitacaoAlterada.reservaUTI = 'ReservaUtiNao'
    if (campoHabilitadoShared(this.template, 'diariaUti')) this.solicitacaoAlterada.diariaUti = null
  }

  todosProcedimentosHospitalDia: boolean = false

  @Mutation
  setTodosProcedimentosHospitalDia(value: boolean) {
    this.todosProcedimentosHospitalDia = value
  }

  @Action
  async getProcedimentosHospitalDiaByHospital() {
    try {
      const params: any = {
        hospitalId: this.solicitacaoAlterada.hospitalId,
        convenioId: this.solicitacaoAlterada.paciente.convenioId,
        procedimentoIds: getProcedimentoIdFromProcedimentos(this.solicitacaoAlterada.procedimento, this.solicitacaoAlterada.procedimentosAssociados),
      }

      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getProcedimentosHospitalDiaByHospital(params)
      if (request.success) this.context.commit('setTodosProcedimentosHospitalDia', request.data.todosProcedimentosHospitalDia as boolean)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  setProcedimentoAssociadosSolicitacaoAlterada(procedimento: any) {
    const index = this.solicitacaoAlterada.procedimentosAssociados.findIndex((p: any) => p.id === procedimento.id)
    this.solicitacaoAlterada.procedimentosAssociados[index] = { ...procedimento }
  }

  @Action
  removeProcedimentosSelectedFromApi() {
    this.hideProcedimentoApi(this.solicitacaoAlterada.procedimento)
    this.solicitacaoAlterada.procedimentosAssociados.forEach((e: Procedimento) => {
      this.hideProcedimentoApi(e)
    })
  }

  @Mutation
  hideProcedimentoApi(value: Procedimento) {
    const procedimento = this.procedimentosApi.find(c => c.id === value.id)
    if (procedimento) {
      procedimento.hide = true
    }
  }

  @Mutation
  showProcedimentoApi(value: Procedimento) {
    const procedimento = this.procedimentosApi.find(c => c.id === value.id)
    if (procedimento) {
      procedimento.hide = false
    }
  }

  @Mutation
  clearSolicitacaoAlterada() {
    this.solicitacaoAlterada = { ...this.solicitacaoAlteradaDefault }
  }

  @Mutation
  setHospitais(value: any) {
    this.hospitais = value
  }

  @Mutation
  setDisableCancelarSolicitacaoButton(value: boolean) {
    this.disableCancelarSolicitacaoButton = value
  }

  @Mutation
  setEquipamentosApi(value: Equipamento[]) {
    this.equipamentosApi = value
  }

  @Mutation
  clearEquipamentosApi() {
    this.equipamentosApi = []
  }


  @Mutation
  setEquipamentoGruposApi({ data, hasHospitalFromNetwork = false }: { data: EquipamentoGrupo[]; hasHospitalFromNetwork: boolean }) {
    const defaultIdEquipment = '00000000-0000-0000-0000-000000000000'
    this.equipamentoGruposApi = data
    let equipments: EquipamentoGrupoChild[] = []

    // Mark the equipments in list as selected if has an equipament in solicitation
    this.equipamentoGruposApi.forEach((grupo) => {
      grupo.equipamentos.forEach((equipamento) => {
        const index = this.equipamentoGruposDaSolicitacao.findIndex((equipamentoGrupoDaSolicitacao) => {
          if (equipamentoGrupoDaSolicitacao.equipamentos.findIndex(elem => (elem.id === equipamento.id) && equipamento.id !== defaultIdEquipment) !== -1) {
            return true
          }
          return false
        })

        if (index !== -1) {
          // eslint-disable-next-line no-param-reassign
          grupo.equipamentSelected = equipamento
          // eslint-disable-next-line no-param-reassign
          grupo.hasEmphasis = true

          if (hasHospitalFromNetwork) {
            equipments = grupo.equipamentos.filter(equipment => equipment.status === 'Ativo')
          }

          const equipamentoGrupoDaSolicitacao: EquipamentoGrupoDaSolicitacao = {
            ...grupo.grupoEquipamento,
            equipamentSelected: grupo.equipamentSelected,
            equipamentos: [grupo.equipamentSelected],
          }

          this.equipamentoGruposDaSolicitacao[index] = cloneDeep(equipamentoGrupoDaSolicitacao)
        } else {
          // eslint-disable-next-line arrow-body-style
          const indexOfGroup = this.equipamentoGruposDaSolicitacao.findIndex((equipamentoGrupoDaSolicitacao) => {
            return equipamentoGrupoDaSolicitacao.id === equipamento.grupoEquipamentoId
          })

          if (indexOfGroup !== -1) {
            // eslint-disable-next-line no-param-reassign
            grupo.hasEmphasis = true

            if (grupo.equipamentos.length === 1) {
              const jaTinhaEquipamentoSelecionado = !!this.equipamentoGruposDaSolicitacao[indexOfGroup].equipamentSelected

              const [equipamentSelected] = grupo.equipamentos
              // eslint-disable-next-line no-param-reassign
              grupo.equipamentSelected = equipamentSelected

              if (hasHospitalFromNetwork) {
                equipments = grupo.equipamentos.filter(equipment => equipment.status === 'Ativo')
              }

              const equipamentoGrupoDaSolicitacao: EquipamentoGrupoDaSolicitacao = {
                ...grupo.grupoEquipamento,
                equipamentSelected: grupo.equipamentSelected,
                equipamentos: [grupo.equipamentSelected],
              }

              this.equipamentoGruposDaSolicitacao[indexOfGroup] = cloneDeep(equipamentoGrupoDaSolicitacao)

              // Único equipamento possível no grupo: a seleção exibida na tela precisa
              // ser gravada de fato (EquipamentoId), senão o radio aparece marcado sem
              // que nada tenha sido persistido no backend.
              if (!jaTinhaEquipamentoSelecionado) {
                this.pendingAutoSelectedEquipamentos.push(cloneDeep(equipamentSelected))
              }
            }
          }
        }
      })
    })
  }

  @Mutation
  updateSelectedEquipmentsApiToSolicitacaoAlterada() {
    this.equipamentoGruposApi.forEach((grupo) => {
      const { grupoEquipamento } = grupo
      const index = this.solicitacaoAlterada.equipamentos.findIndex(elem => elem.id === grupoEquipamento.id)
      if (index !== -1) {
        // eslint-disable-next-line no-param-reassign
        grupo.isSelected = true
      }
    })
  }

  @Mutation
  clearEquipamentoGruposApi() {
    this.equipamentoGruposApi = []
    this.equipamentoGruposDaSolicitacao = []
  }

  @Mutation
  clearPendingAutoSelectedEquipamentos() {
    this.pendingAutoSelectedEquipamentos = []
  }

  @Mutation
  addEquipamento(equipamentoGrupo: EquipamentoGrupoDaSolicitacao) {
    const index = this.equipamentoGruposDaSolicitacao.findIndex(elem => elem.id === equipamentoGrupo.id)

    const data = cloneDeep(equipamentoGrupo)

    if (index !== -1) {
      this.equipamentoGruposDaSolicitacao[index] = data
    } else {
      this.equipamentoGruposDaSolicitacao.push(data)
    }

    const equipmentToAddEmphasis = this.equipamentoGruposApi.find(elem => elem.grupoEquipamento.id === equipamentoGrupo.id)
    if (equipmentToAddEmphasis) {
      equipmentToAddEmphasis.hasEmphasis = true
    }
  }

  @Mutation
  removeEquipamento(equipamentoGrupo: EquipamentoGrupoDaSolicitacao) {
    const index = this.equipamentoGruposDaSolicitacao.findIndex(elem => elem.id === equipamentoGrupo.id)
    if (index !== -1) {
      this.equipamentoGruposDaSolicitacao.splice(index, 1)
    }

    const equipmentToRemoveSelected = this.equipamentoGruposApi.find(elem => elem.grupoEquipamento.id === equipamentoGrupo.id)
    if (equipmentToRemoveSelected) {
      equipmentToRemoveSelected.hasEmphasis = false
      equipmentToRemoveSelected.equipamentSelected = undefined
    }
  }

  @Mutation
  addEquipamentoSolicitacaoAlterada(grupoId: string) {
    const grupo = this.equipamentoGruposApi.find(elem => elem.grupoEquipamento.id === grupoId)
    if (grupo) {
      grupo.isSelected = true

      const { grupoEquipamento } = grupo
      this.solicitacaoAlterada.equipamentos.push(grupoEquipamento)
    }
  }

  @Mutation
  removeEquipamentoSolicitacaoAlterada(grupoId: string) {
    const grupo = this.equipamentoGruposApi.find(elem => elem.grupoEquipamento.id === grupoId)
    if (grupo) {
      grupo.isSelected = false

      const index = this.solicitacaoAlterada.equipamentos.findIndex(elem => elem.id === grupoId)
      if (index !== -1) {
        this.solicitacaoAlterada.equipamentos.splice(index, 1)
      }
    }
  }

  // #endregion Grupo equipamento métodos

  @Mutation
  setEquipamentos(equipamentos: IBackofficeGlobalStoreEquipamento) {
    this.equipamentoGruposDaSolicitacao = equipamentos.equipamentosDaSolicitacao
    this.equipamentosSugeridos = equipamentos.equipamentosSugeridos

    let equipamentosDaSolicitacao: Equipamento[] = []

    equipamentos.equipamentosDaSolicitacao.forEach((elem) => {
      equipamentosDaSolicitacao = equipamentosDaSolicitacao.concat(elem.equipamentos)
    })

    this.equipamentos = equipamentosDaSolicitacao
  }

  @Mutation
  clearEquipamentos() {
    this.equipamentos = []
  }

  @Mutation
  removeDuplicates() {
    const equipamentoIds = _.map(this.equipamentos, 'id') || []
    if (equipamentoIds.length === 0) return
    equipamentoIds.forEach((id: string) => {
      const index = this.equipamentosApi.findIndex((e: Equipamento) => e.id === id)
      this.equipamentosApi.splice(index, 1)
    })
  }

  @Mutation
  setAgendamentoMedicoId(value: string) {
    this.agendamentoMedicoId = value
  }

  @Mutation
  clearAgendamentoMedicoId() {
    this.agendamentoMedicoId = ''
  }

  @Mutation
  setShowModalVoltarStatus(value: boolean) {
    this.modal.voltarStatus = value
  }

  @Mutation
  setFinalizarTriagemReservaSala(reservaSala: SendReservaSala) {
    this.agendamentoConfirmarTriagem = {
      dataAgendamento: moment(`${reservaSala.data} ${reservaSala.hora}`, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm'),
      dataAgendamentoVirtual: reservaSala.dataAgendamentoVirtual,
      numeroAgendamento: reservaSala.numeroAgendamento,
      solicitacaoId: reservaSala.solicitacaoId,
      tempoCirurgia: reservaSala.tempoCirurgia,
    }
  }

  @Mutation
  setNovaDataAgendamentoCirurgia(agendamentoCirurgia: any) {
    this.novaDataSolicitada.solicitacaoId = agendamentoCirurgia.id
    this.novaDataSolicitada.dataAgendamento = agendamentoCirurgia.dataAgendamento
    this.novaDataSolicitada.dataAgendamentoVirtual = agendamentoCirurgia.dataAgendamentoVirtual
    this.novaDataSolicitada.opcaoDataPrevisto1 = agendamentoCirurgia.opcaoDataPrevisto1
    this.novaDataSolicitada.opcaoDataPrevisto2 = agendamentoCirurgia.opcaoDataPrevisto2
    this.novaDataSolicitada.opcaoDataPrevisto3 = agendamentoCirurgia.opcaoDataPrevisto3
    this.novaDataSolicitada.numeroAgendamento = agendamentoCirurgia.numeroAgendamento
    this.acoes = agendamentoCirurgia.acoes
  }

  @Mutation
  setHealthInsuranceData(healthInsuranceData: Convenio) {
    this.healthInsuranceData = healthInsuranceData
  }

  @Mutation
  setloadDataAgendamento() {
    if (this.novaDataSolicitada.dataAgendamento) {
      this.novaDataSolicitada.opcao = 0
      this.novaDataSolicitada.data = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYY')
      this.novaDataSolicitada.hora = moment(this.novaDataSolicitada.dataAgendamento).format('HHmm')
    }

    if (this.novaDataSolicitada.dataAgendamento) {
      const dataSolicitacao = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYYHmm')
      const opcao1 = moment(this.novaDataSolicitada.opcaoDataPrevisto1).format('DDMMYYYYHmm')
      const opcao2 = moment(this.novaDataSolicitada.opcaoDataPrevisto2).format('DDMMYYYYHmm')
      const opcao3 = moment(this.novaDataSolicitada.opcaoDataPrevisto3).format('DDMMYYYYHmm')

      switch (dataSolicitacao) {
        case opcao1:
          this.novaDataSolicitada.opcao = 1
          break

        case opcao2:
          this.novaDataSolicitada.opcao = 2
          break

        case opcao3:
          this.novaDataSolicitada.opcao = 3
          break

        default:
          this.novaDataSolicitada.opcao = 0
          this.novaDataSolicitada.data = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYY')
          this.novaDataSolicitada.hora = moment(this.novaDataSolicitada.dataAgendamento).format('HHmm')
          break
      }
    }
  }

  @Mutation
  setAcoes(acoes: Acoes) {
    this.acoes = acoes
  }

  @Mutation
  setModal(modal: any) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setStatusAguardandoOperadora(status: string) {
    this.solicitacao.statusAguardandoOperadora = status
  }

  @Mutation
  setFormAutorizacao(params: any) {
    this.solicitacao.protocoloOPME = params.protocoloOPME
    this.solicitacao.protocoloOperadora = params.protocoloOperadora
    this.solicitacao.autorizacaoValidade = params.autorizacaoValidade
    this.solicitacao.dataAutorizacaoNaOperadora = params.dataAutorizacaoNaOperadora
    this.solicitacao.autorizacaoObservacao = params.autorizacaoObservacao
    this.solicitacao.operadoraSenha = params.operadoraSenha
    this.solicitacao.operadoraSenhaProvisoria = params.operadoraSenhaProvisoria
    this.solicitacao.operadoraQuantidadeDiasAutorizado = params.operadoraQuantidadeDiasAutorizado
    this.solicitacao.statusAguardandoOperadora = params.statusAguardandoOperadora
  }

  @Mutation
  setNovaDataSolicitadaSelect(value: string | null) {
    this.novaDataSolicitada.dataAgendamento = value
    this.novaDataSolicitada.opcao = 0

    if (value) {
      const v = moment(value).format('YYYYDDMMHHmm')
      for (let index = 1; index < 4; index++) {
        const data = this.novaDataSolicitada[`opcaoDataPrevisto${index}`]
        const f = moment(data).format('YYYYDDMMHHmm')
        if (v === f) {
          this.novaDataSolicitada.opcao = index
        }
      }
    }
  }

  @Mutation
  setSolicitacao(solicitacao: Solicitacao) {
    const solicit: Solicitacao = { ...solicitacao }
    if (solicit.procedimento && !solicit.procedimento.quantidadeAutorizada) {
      solicit.procedimento.quantidadeAutorizada = 0
    }

    if (solicit.procedimentosAssociados) {
      solicit.procedimentosAssociados.map((c) => {
        const t = c
        if (!t.quantidadeAutorizada) {
          t.quantidadeAutorizada = 0
        }
        return t
      })
    }

    if (solicit.procedimentosInternacao) {
      solicit.procedimentosInternacao.map((c) => {
        const t = c
        if (!t.quantidadeAutorizada) {
          t.quantidadeAutorizada = 0
        }
        return t
      })
    }

    if (!solicit.solicitacaoProcedimentoInternacao) {
      solicit.solicitacaoProcedimentoInternacao = {
        id: '',
        solicitacaoId: '',
        procedimentoInternacaoId: '',
        procedimentoInternacao: {
          id: '',
          codigo: '',
          descricao: '',
          tipo: '',
        },
        quantidade: 0,
        quantidadeAutorizada: 0,
      }
    }

    this.solicitacao = solicit
  }

  @Mutation
  setProcedimentosAssociados(procedimento: any) {
    if (this.solicitacao.procedimentosAssociados) {
      const procedimentos = [this.solicitacao.procedimento, ...this.solicitacao.procedimentosAssociados]
      const exists = procedimentos.some((e: any) => e.id === procedimento.id)
      const procedimentoEditavel = { ...procedimento, editable: true, quantidadeAutorizada: 0 }
      !exists && this.solicitacao.procedimentosAssociados.push(procedimentoEditavel)
    }
  }

  @Mutation
  removeProcedimentoAssociado(procedimento: any) {
    if (this.solicitacao.procedimentosAssociados) {
      const index = this.solicitacao.procedimentosAssociados.findIndex((e: any) => e.id === procedimento.id && e.editable === true)
      this.solicitacao.procedimentosAssociados.splice(index, 1)
    }
  }

  @Mutation
  setProcedimentoApi(procedimento: Procedimento) {
    this.procedimentosApi.push(procedimento)
  }

  @Mutation
  removeProcedimentosAssociadoBackoffice(procedimentoId: string) {
    if (this.solicitacaoAlterada.procedimentosAssociados) {
      const index = this.solicitacaoAlterada.procedimentosAssociados.findIndex((e: any) => e.id === procedimentoId)
      this.solicitacaoAlterada.procedimentosAssociados.splice(index, 1)
    }
  }

  @Mutation
  removeGrupoOpmeBackoffice(grupoOpmeId: string) {
    if (this.solicitacaoAlterada.grupoOpmeDaSolicitacao) {
      const index = this.solicitacaoAlterada.grupoOpmeDaSolicitacao.findIndex((e: any) => e.id === grupoOpmeId)
      this.solicitacaoAlterada.grupoOpmeDaSolicitacao.splice(index, 1)
    }
  }

  @Mutation
  setHospitalId(hospitalId: string) {
    this.solicitacao.hospitalId = hospitalId
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.solicitacao.id = solicitacaoId
  }

  @Mutation
  setNovaDataAgendamento(dataAgendamento: string) {
    this.novaDataSolicitada.dataAgendamento = dataAgendamento
  }

  @Mutation
  fillHemocomponentes(hemocomponentes: Hemocomponente[]) {
    hemocomponentes.map((c: Hemocomponente) => {
      switch (_.toUpper(c.tipo)) {
        case 'CONCENTRADOHEMACIAS':
          this.reservaHemocomponentes.concentradoHemacias.value = true
          this.reservaHemocomponentes.concentradoHemacias.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.concentradoHemacias.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.concentradoHemacias.quantidade = c.quantidade
          break
        case 'CONCENTRADOPLAQUETAS':
          this.reservaHemocomponentes.concentradoPlaquetas.value = true
          this.reservaHemocomponentes.concentradoPlaquetas.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.concentradoPlaquetas.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.concentradoPlaquetas.quantidade = c.quantidade
          break
        case 'CRIOPRECIPITADO':
          this.reservaHemocomponentes.crioprecipitado.value = true
          this.reservaHemocomponentes.crioprecipitado.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.crioprecipitado.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.crioprecipitado.quantidade = c.quantidade
          break
        case 'PLASMAFRESCOCONGELADO':
          this.reservaHemocomponentes.plasmaFrescoCongelado.value = true
          this.reservaHemocomponentes.plasmaFrescoCongelado.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.plasmaFrescoCongelado.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.plasmaFrescoCongelado.quantidade = c.quantidade
          break
        case 'TIPAGEMSANGUINEAABORHPAI':
          this.reservaHemocomponentes.tipagemSanguineaABORHPAI.value = true
          this.reservaHemocomponentes.tipagemSanguineaABORHPAI.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.tipagemSanguineaABORHPAI.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.tipagemSanguineaABORHPAI.quantidade = c.quantidade
          break
        case 'TIPAGEMSANGUINEA':
          this.reservaHemocomponentes.tipagemSanguinea.value = true
          this.reservaHemocomponentes.tipagemSanguinea.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.tipagemSanguinea.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.tipagemSanguinea.quantidade = c.quantidade
          break
        case 'SEMRESERVA':
          this.reservaHemocomponentes.semReserva.value = true
          this.reservaHemocomponentes.semReserva.quantidade = c.quantidade
          this.solicitacaoAlterada.reservaHemocomponentes.semReserva.value = true
          this.solicitacaoAlterada.reservaHemocomponentes.semReserva.quantidade = c.quantidade
          break
        default:
          break
      }

      return c
    })
  }

  @Mutation
  clearReservaHemocomponentes() {
    this.reservaHemocomponentes = { ...this.reservaHemocomponentesDefault }
  }

  @Mutation
  clearSolicitacaoFromList() {
    this.solicitationFromList = {} as Solicitacao
  }

  @Mutation
  clearSolicitacao() {
    this.solicitacao = { ...this.solicitacaoDefault }
  }

  @Mutation
  clearNovaDataSolicitada() {
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  }

  @Mutation
  clearAgendamentoConfirmarTriagem() {
    this.agendamentoConfirmarTriagem = { ...this.agendamentoConfirmarTriagemDefault }
  }

  @Mutation
  setDoctors(doctorInfo) {
    this.doctors = doctorInfo
  }

  @Mutation
  setDoctorSignature(doctorSignature: any) {
    this.solicitacao.medicoSolicitante.assinatura = doctorSignature || ''
  }

  @Mutation
  setExecutantDoctorModal(modalInfo) {
    this.executantDoctorModal = modalInfo
  }

  @Mutation
  setLaudos(value: any) {
    if (value) {
      if (!this.solicitacao.laudos) {
        this.solicitacao.laudos = []
      }

      this.solicitacao.laudos.push(value)
    }
  }

  @Mutation
  deleteLaudoById(id: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.solicitacao.laudos.length; i++) {
      if (this.solicitacao.laudos[i].id === id) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.solicitacao.laudos.splice(removeArray[i], 1)
    }
  }

  @Mutation
  setTipoAnestesia(value: any) {
    this.solicitacao.tipoAnestesiaTemp = value
  }

  @Action
  clearTipoAnestesia() {
    this.solicitacao.tipoAnestesiaTemp = []
    this.context.commit('clearOutrosTipoAnestesia')
  }

  @Mutation
  clearOutrosTipoAnestesia() {
    this.solicitacao.outrosTipoAnestesia = ''
  }

  @Mutation
  setOutrosTipoAnestesia(value: string) {
    this.solicitacao.outrosTipoAnestesia = value
  }

  @Mutation
  setAlergiaLatex(value: number | boolean | null) {
    this.solicitacao.alergiaLatex = value
  }

  @Mutation
  setAlergiaContraste(value: boolean | null) {
    this.solicitacao.alergiaContraste = value
  }

  @Mutation
  setOutrasAlergias(value: boolean | null) {
    this.solicitacao.outrasAlergias = value
  }

  @Mutation
  setEspecificarOutrasAlergias(value: string | null) {
    this.solicitacao.especificarOutrasAlergias = value
  }

  @Mutation
  setCodigoUnico(codigo: string) {
    const { grupoOpmeDaSolicitacao } = this.solicitacao
    grupoOpmeDaSolicitacao.map(i => i.opmes.map((e) => {
      const temp: any = e
      temp.codigoHospital = codigo
      return temp
    }))
  }

  @Mutation
  setReservaUTI(value: string) {
    if (value) {
      switch (value.toLowerCase()) {
        case 'adulto':
          this.solicitacao.reservaUTI = { key: 'Adulto', display: 'Adulto' }
          break
        case 'geral':
          this.solicitacao.reservaUTI = { key: 'Geral', display: 'Geral' }
          break
        case 'pediatrica':
          this.solicitacao.reservaUTI = { key: 'Pediatrica', display: 'Pediátrica' }
          break
        case 'neonatal':
          this.solicitacao.reservaUTI = { key: 'NeoNatal', display: 'Neo Natal' }
          break
        default:
          this.solicitacao.reservaUTI = { key: 'SemReserva', display: 'Sem Reserva' }
      }
    }
    this.solicitacao.reservaUtiTemp = this.solicitacao.reservaUTI.key
  }

  @Mutation
  setViasAereasDificilAcesso(value: boolean | null) {
    this.solicitacao.viasAereasDificilAcesso = value
  }

  @Mutation
  setPacienteUsaMarcaPasso(value: boolean | null) {
    this.solicitacao.pacienteUsaMarcaPasso = value
  }

  @Mutation
  setHistoricoFamiliarHipertemia(value: boolean | null) {
    this.solicitacao.historicoFamiliarHipertemiaMaligna = value
  }

  @Mutation
  setClassificacaoAsa(value: ClassificacaoAsaEnum | null) {
    this.solicitacao.classificacaoAsa = value
  }

  @Mutation
  setPacienteAptoParaAnestesia(value: boolean | null) {
    this.solicitacao.pacienteAptoParaAnestesia = value
  }

  @Mutation
  setObservacaoPreAnestesia(value: string | null) {
    this.solicitacao.observacaoPreAnestesia = value
  }

  @Mutation
  setObservacaoComplementares(value: string | null) {
    this.solicitacao.observacaoComplementares = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupo(value: any) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoFaturamento(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoComentarios(value: string) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.comentarios = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoDataReferenciaParaOperadora(value: string | Date) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora = value
    }
  }

  @Mutation
  setCodigoPrestadorSolicitante(value: string) {
    this.solicitacao.codigoPrestadorSolicitante = value
  }

  @Mutation
  setCodigoUnicoMaterial(value: string) {
    this.solicitacao.codigoUnicoMaterial = value
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoNotaFiscal(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.notaFiscal = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoObservacao(value: string) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.observacao = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoValor(value: string | number | null) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.valor = value
    }
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoCotacaoComUrgencia(value: boolean) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia = value
    }
  }

  @Mutation
  clearCotacaoOperadorasExtraGrupo() {
    this.solicitacao.cotacaoOperadorasExtraGrupo = { ...this.cotacaoOperadorasExtraGrupoDefault }
  }

  @Mutation
  clearFaturamentoExtraGrupo() {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) {
      this.solicitacao.cotacaoOperadorasExtraGrupo.observacao = ''
      this.solicitacao.cotacaoOperadorasExtraGrupo.valor = ''
      this.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia = false
      this.solicitacao.cotacaoOperadorasExtraGrupo.comentarios = ''
      this.solicitacao.cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora = ''
    }
  }

  @Mutation
  setProtocoloOpmeMessage(message: string) {
    this.protocoloOpmeMessage.protocoloOPMEMessage = message
  }

  @Mutation
  setProtocoloOperadoraMessage(message: string) {
    this.protocoloOpmeMessage.protocoloOperadoraMessage = message
  }

  @Mutation
  async setContestacaoMedicaMensagem(value: ContestacaoMedicaMensagem) {
    this.contestacaoMedica.mensagens.push(value)
  }

  @Mutation
  setTipoEnvioMensagem(tipoEnvio: TipoEnvioMensagemEnum) {
    this.tipoEnvioMensagem = tipoEnvio
  }

  @Mutation
  setContestacaoMedica(contestacao: ContestacaoMedica) {
    this.contestacaoMedica = contestacao
  }

  @Mutation
  clearContestacaoMedica() {
    this.contestacaoMedica = { ...this.contestacaoMedicaDefault }
  }

  @Mutation
  clearAutorizacao() {
    this.protocoloOpmeMessage = { ...this.protocoloOpmeMessageDefault }
  }

  @Mutation
  setAutorizacaoValidade(value: string) {
    this.solicitacao.autorizacaoValidade = value
  }

  @Mutation
  setDataAutorizacaoNaOperadora(value: string) {
    this.solicitacao.dataAutorizacaoNaOperadora = value
  }

  @Mutation
  setTemplate(value: any) {
    this.template = value
  }

  @Mutation
  clearTemplate() {
    this.template = {}
  }

  @Mutation
  setSolicitationFromList(value: Solicitacao) {
    this.solicitationFromList = value
  }

  @Mutation
  setProcedimentosApi(procedimentosRequest: any) {
    if (procedimentosRequest.success) {
      const procedimentos = [...procedimentosRequest.data]
      const { procedimentosAssociados } = this.solicitacao
      const procedimento = this.solicitacao.procedimento || this.procedimentoDefault
      const procedimentosAssociadosIds: string[] = []

      if (procedimentosAssociados && procedimentosAssociados.length > 0) {
        procedimentosAssociados.map((e: any) => procedimentosAssociadosIds.push(e.id))
        procedimentosAssociadosIds.forEach((e: string) => {
          const indexAssociados = procedimentos.findIndex(c => c.id === e)
          if (![-1, null, undefined].includes(indexAssociados)) procedimentos.splice(indexAssociados, 1)
        })
      }

      if (!['', null, undefined].includes(procedimento!.id)) {
        const indexPrincipal = procedimentos.findIndex(c => c.id === procedimento!.id)
        if (![-1, null, undefined].includes(indexPrincipal)) procedimentos.splice(indexPrincipal, 1)
      }

      if (this.template.formulario
        && this.template.formulario.lateralidade
        && this.template.formulario.lateralidade.exigeLateralidadeEmTodosOsProcedimentos) {
        this.procedimentosApi = procedimentos.map((proced: any) => {
          const proc = proced
          proc.temLateralidade = true
          return proc
        })
      } else {
        this.procedimentosApi = procedimentos
      }
    } else {
      this.procedimentosApi = []
    }
  }

  @Mutation
  removeFromProcedimentosApi(procedimentoId: string) {
    const procedimentoIndex = this.procedimentosApi.findIndex((e: any) => e.id === procedimentoId)
    if (![-1, null, undefined].includes(procedimentoIndex)) this.procedimentosApi.splice(procedimentoIndex, 1)
  }

  @Mutation
  addProcedimentoPrincipal(value: Procedimento) {
    this.solicitacao.procedimento = value
  }

  @Mutation
  removeProcedimentoPrincipal(id: string) {
    const index = this.procedimentosApi.findIndex((e: any) => e.id === id)
    this.procedimentosApi.splice(index, 1)
  }


  @Mutation
  clearProcedimentosApi() {
    this.procedimentosApi = [...this.procedimentosApiDefault]
  }

  @Mutation
  removeProcedimentoApi(value: Procedimento) {
    const index = this.procedimentosApi.findIndex(c => c.id === value.id)
    if (index > -1) {
      this.procedimentosApi.splice(index, 1)
    }
  }

  @Mutation
  setAllOpmeFazCotacao(value: boolean) {
    const opmeFazCotacaoPorPadrao = this.template.formulario
      && this.template.formulario.suprimentosCotacao
      && this.template.formulario.suprimentosCotacao.campos
      && this.template.formulario.suprimentosCotacao.campos.flagCotacaoDefault

    this.solicitacao.grupoOpmeDaSolicitacao.forEach((grupo: any) => {
      grupo.opmes.map((opme: any) => {
        const op = opme
        op.fazCotacao = value ? false : opmeFazCotacaoPorPadrao
        return op
      })
    })
  }

  @Action
  async getPacienteInfoByNomeAndDataNascimento(params: any) {
    const nome = params.nome.trim()
    const { dataNascimento } = params
    const { hospitalId } = this.solicitacao
    const response = await this.solicitacaoCirurgiaImp.getPacienteByHospital(hospitalId, { nome, dataNascimento, origemBackoffice: true })
    if (response.success) {
      const pacientes = response.data.pacientes
        ? response.data.pacientes.map((e: any) => e.paciente)
        : []
      this.context.commit('setPacientesLista', pacientes)
    }

    return response
  }

  @Action
  async getPacienteInfo(params: any) {
    const { cpf } = params
    const { rgh } = params
    const { hospitalId } = this.solicitacao
    const response = await this.solicitacaoCirurgiaImp.getPacienteByHospital(hospitalId, { cpf, rgh, origemBackoffice: true })
    if (response.success) {
      const pacientes = response.data.pacientes
        ? response.data.pacientes.map((e: any) => e.paciente)
        : []
      this.context.commit('setPacientesLista', pacientes)
    }

    return response
  }


  @Mutation
  setDesfazCancelamento(value: boolean) {
    this.desfazCancelamento = value
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'fillHemocomponentes' })
  async getReservaHemocomponente() {
    const solicitacaoId = this.solicitacao.id || this.solicitacaoAlterada.id
    const request = await this.autorizacao.getReservaHemocomponentes(solicitacaoId)
    return request.success ? request.data : []
  }

  @Action
  async backofficeAgendamentoRealizaPreAgendamento(reservaDeSala: any = null) {
    try {
      const dataAgendamento = this.solicitacao.dataAgendamento || undefined
      const dataAgendamentoVirtual = this.solicitacao.dataAgendamentoVirtual !== undefined ? this.solicitacao.dataAgendamentoVirtual : false
      const numeroAgendamento = this.solicitacao.numeroAgendamento || undefined

      const params: any = {
        solicitacaoId: this.solicitacao.id,
        reservaData: {
          dataAgendamento,
          dataAgendamentoVirtual,
          numeroAgendamento,
        },
        reservaSala: reservaDeSala,
      }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await this.agendamento.backofficeAgendamentoRealizaPreAgendamento(params)
      return request
    } catch (error) {
      return false
    }
  }

  @Action
  async backofficeAgendamentoRealizaRevisaoCirurgica() {
    try {
      const request = await this.agendamento.backofficeAgendamentoRealizaRevisaoCirurgica({
        solicitacaoId: this.solicitacao.id,
        solicitacao: this.solicitacao,
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async finalizarReservaSalaTriagem(params: any) {
    const response = await this.triagem.backofficeAgendamentoRealizaTriagem(this.solicitacao.id, params)
    return response
  }

  @Action
  async finalizarTriagem() {
    const dataAgendamento = this.solicitacao.dataAgendamento || undefined
    // eslint-disable-next-line eqeqeq
    const dataAgendamentoVirtual = this.solicitacao.dataAgendamentoVirtual != undefined ? this.solicitacao.dataAgendamentoVirtual : false
    const numeroAgendamento = this.solicitacao.numeroAgendamento || undefined

    const confirmarTriagem: any = {
      reservaData: {
        dataAgendamento,
        dataAgendamentoVirtual,
        numeroAgendamento,
      },
    }

    const response = await this.triagem.backofficeAgendamentoRealizaTriagem(this.solicitacao.id, confirmarTriagem)
    return response
  }

  @Action
  async finalizarTriagemParticular() {
    const solicitacaoId: string = this.solicitacao.id
    const response = await this.triagem.backofficeAgendamentoRealizaTriagemParticular(solicitacaoId, '')
    return response
  }

  @Action
  async enviarNotificacaoWhatsapp(etapaDeNotificacao: string) {
    const { id } = this.solicitacao
    const response = await this.triagem.enviarNotificacaoWhatsapp(id, { etapaDeNotificacao })
    return response
  }

  @Action
  async getCheckNumeroReserva(params: any) {
    const request = await this.triagem.getCheckNumeroReserva(params)
    return request.data
  }

  @Action
  dataAgendamentoRadioGroup() {
    const { opcao } = this.novaDataSolicitada
    const dataSelecionada = this.novaDataSolicitada[`opcaoDataPrevisto${opcao}`]
    this.context.commit('setNovaDataSolicitadaSelect', dataSelecionada)
  }

  @Action
  async solicitacaoAuditada(params: any) {
    const request = await this.agendamento.solicitacaoAuditada(params)
    return request.success
  }

  @Action
  async getDoctorSignature(doctorId: string) {
    try {
      const doctorSignatureAPIResponse = await this.agendamento.getDoctorSignature(doctorId)

      if (doctorSignatureAPIResponse.success) {
        const { assinaturaMedico: doctorSignature } = doctorSignatureAPIResponse.data
        this.context.commit('setDoctorSignature', doctorSignature)
      }

      return doctorSignatureAPIResponse
    } catch (error) {
      this.context.commit('setDoctorSignature', '')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSolicitacaoById(solicitacaoId: string) {
    const params: any = {
      solicitacaoId,
      area: this.backofficeArea,
    }

    const response = await this.agendamento.getSolicitacaoById(params)
    if (response.success) {
      const solicitacaoCast: Solicitacao = response.data

      if (!solicitacaoCast.statusPrecificacaoOperadora) {
        solicitacaoCast.statusPrecificacaoOperadora = null
      }

      if (!solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = null
      }

      if (solicitacaoCast.cotacaoOperadorasExtraGrupo !== null) {
        const { dataReferenciaParaOperadora } = solicitacaoCast.cotacaoOperadorasExtraGrupo
        // @ts-ignore
        if (!['', null, undefined].includes(dataReferenciaParaOperadora)) {
          // @ts-ignore
          solicitacaoCast.cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora = solicitacaoCast.cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora.slice(0, 10)
        }
      }

      // @ts-ignore
      if ([null, undefined].includes(solicitacaoCast.outrasAlergias)) {
        solicitacaoCast.outrasAlergias = null
      }

      if (solicitacaoCast.temOpme && !solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = { ...this.cotacaoOperadorasExtraGrupoDefault }
      }

      if (!solicitacaoCast.protocoloOperadora) {
        solicitacaoCast.protocoloOperadora = ''
      }

      if (!solicitacaoCast.protocoloOPME) {
        solicitacaoCast.protocoloOPME = ''
      }

      if (!solicitacaoCast.dataAgendamento) {
        solicitacaoCast.dataAgendamento = ''
      }

      if (!solicitacaoCast.autorizacaoObservacao) {
        solicitacaoCast.autorizacaoObservacao = ''
      }

      if (!solicitacaoCast.observacaoReservaSala) {
        solicitacaoCast.observacaoReservaSala = null
      }

      /* Esse status é usado para salvar o novo status enviado pela operadora na etapa aguardando operadora */
      solicitacaoCast.statusAguardandoOperadora = solicitacaoCast.situacao.key

      this.context.commit('setAcoes', response.data.acoes)
      this.context.commit('setNovaDataAgendamentoCirurgia', solicitacaoCast)
      this.context.commit('setloadDataAgendamento', solicitacaoCast)

      const tipoArray: any[] = []
      solicitacaoCast.tipoAnestesia.forEach((c: any) => {
        if (c.outrosTipoAnestesia) {
          solicitacaoCast.outrosTipoAnestesia = c.outrosTipoAnestesia
        }
        tipoArray.push(c.tipo.key)
      })

      solicitacaoCast.reservaUtiTemp = solicitacaoCast.reservaUTI.key

      if (!solicitacaoCast.autorizacaoValidade) {
        solicitacaoCast.autorizacaoValidade = ''
      } else {
        solicitacaoCast.autorizacaoValidade = moment(solicitacaoCast.autorizacaoValidade).format('YYYY-MM-DD')
      }

      if (!solicitacaoCast.dataAutorizacaoNaOperadora) {
        solicitacaoCast.dataAutorizacaoNaOperadora = ''
      } else {
        solicitacaoCast.dataAutorizacaoNaOperadora = moment(solicitacaoCast.dataAutorizacaoNaOperadora).format('YYYY-MM-DD')
      }

      if (!solicitacaoCast.auditada) {
        solicitacaoCast.auditada = false
        solicitacaoCast.auditadaObservacao = ''
      }

      if (solicitacaoCast.grupoOpmeDaSolicitacao) {
        this.context.commit('setGrupoOpmeApi', JSON.parse(JSON.stringify(response.data.grupoOpmeDaSolicitacao)))

        if (!!solicitacaoCast.grupoOpmeDaSolicitacao.length && getRoute().name === 'BackofficeAutorizacao') {
          solicitacaoCast.grupoOpmeDaSolicitacao.map((grupo: any) => {
            grupo.opmes.map((opme: any) => {
              // eslint-disable-next-line
              if (!opme.quantidadeAutorizada) opme.quantidadeAutorizada = 0
              // eslint-disable-next-line
              if (!opme.tipo) opme.tipo = 'Opme'
              // eslint-disable-next-line
              if (!opme.codigoHospital) opme.codigoHospital = ''
              return opme
            })
            return grupo
          })
        }
        if (!!solicitacaoCast.grupoOpmeDaSolicitacao.length && getRoute().name === 'BackofficeSuprimentos') {
          solicitacaoCast.grupoOpmeDaSolicitacao.map((grupo: any) => {
            grupo.opmes.map((opme: any) => {
              if (solicitacaoCast.configuracaoOpme.fazPrecificacaoOperadora) {
                if ([null, undefined].includes(opme.precificado) && solicitacaoCast.situacao.key !== 'AguardandoSuprimentos') opme.precificado = true
              }
              return opme
            })
            return grupo
          })
          // Solicitação particular deve fazer cotação
          if (solicitacaoCast.situacao.key === 'AguardandoSuprimentos' && solicitacaoCast.convenioParticular) {
            solicitacaoCast.grupoOpmeDaSolicitacao.map((grupo: any) => {
              grupo.opmes.map((opme: any) => {
                opme.fazCotacao = this.template
                  && this.template.formulario
                  && this.template.formulario.suprimentosCotacao
                  && this.template.formulario.suprimentosCotacao.campos
                  && this.template.formulario.suprimentosCotacao.campos.flagCotacaoParticularDefault
                return opme
              })
              return grupo
            })
          }
        }
        if (!!solicitacaoCast.grupoOpmeDaSolicitacao.length && ['AnalisePreCotacao'].includes(solicitacaoCast.situacao.key)) {
          solicitacaoCast.grupoOpmeDaSolicitacao.map((grupo: any) => {
            grupo.opmes.map((opme: any) => {
              opme.fazCotacao = this.template
                && this.template.formulario
                && this.template.formulario.suprimentosCotacao
                && this.template.formulario.suprimentosCotacao.campos
                && this.template.formulario.suprimentosCotacao.campos.flagCotacaoDefault
              return opme
            })
            return grupo
          })
        }
      }

      if (['AguardandoOperadora', 'AutorizadaParcial', 'AutorizadaAceitaMedico', 'Autorizada'].includes(solicitacaoCast.situacao.key)) {
        if (!solicitacaoCast.materiaisCotadosOpme) {
          solicitacaoCast.materiaisCotadosOpme = {
            materiaisEstoque: setMateriaisCotadosOpme(solicitacaoCast.grupoOpmeDaSolicitacao),
          }
        }

        if (solicitacaoCast.procedimento) {
          solicitacaoCast.procedimento = {
            ...solicitacaoCast.procedimento,
            observacaoDaAutorizacao: solicitacaoCast.procedimento.observacaoDaAutorizacao || '',
          }
        }

        if (solicitacaoCast.procedimentosAssociados && solicitacaoCast.procedimentosAssociados.length > 0) {
          solicitacaoCast.procedimentosAssociados = solicitacaoCast.procedimentosAssociados.map((procedimento: Procedimento) => {
            const proc = { ...procedimento }
            if (proc.observacaoDaAutorizacao === undefined) {
              proc.observacaoDaAutorizacao = ''
            }
            return proc
          })
        }
      }

      if (!solicitacaoCast.hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos) {
        solicitacaoCast.hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos = false
      }

      if (['', null, undefined].includes(solicitacaoCast.operadoraSenha)) solicitacaoCast.operadoraSenha = ''
      // @ts-ignore
      if (['', null, undefined, []].includes(solicitacaoCast.outrasSolicitacoesNaoRealizadasDoPaciente)) solicitacaoCast.outrasSolicitacoesNaoRealizadasDoPaciente = []
      if (['', null, undefined].includes(solicitacaoCast.operadoraSenhaProvisoria)) solicitacaoCast.operadoraSenhaProvisoria = ''
      if (['', 0, null, undefined].includes(solicitacaoCast.operadoraQuantidadeDiasAutorizado)) solicitacaoCast.operadoraQuantidadeDiasAutorizado = null

      solicitacaoCast.tipoAnestesiaTemp = tipoArray

      if (solicitacaoCast.procedimentosInternacao) this.context.commit('setProcedimentosInternacaoSelected', solicitacaoCast.procedimentosInternacao)
      // @ts-ignore
      if ('classificacaoASA' in solicitacaoCast) solicitacaoCast.classificacaoAsa = solicitacaoCast.classificacaoASA

      if ('orcamentoPagamento' in solicitacaoCast) this.context.commit('setOrcamentoPagamento', solicitacaoCast.orcamentoPagamento)

      // eslint-disable-next-line eqeqeq
      if (solicitacaoCast.bloquearIntegracaoAutorizador == undefined) {
        solicitacaoCast.bloquearIntegracaoAutorizador = false
      }

      this.context.commit('setSolicitacao', solicitacaoCast)
    }

    return response
  }

  @Action
  async getDoctors() {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMedicoshospitalByUserCurrent()

    if (request.success) {
      const formattedDoctorsData = await this
        .forceCast<Array<{ id: string, nome: string }[]>>(request.data)

      this.context.commit('setDoctors', formattedDoctorsData)
    }

    return request
  }

  @Action
  async updateExecutantDoctor({ executantDoctorId, surgerySolicitationId }): Promise<any> {
    const APIResponse = await Apis.Agendamento.SolicitacaoCirurgiaApi.updateExecutantDoctor(
      executantDoctorId,
      surgerySolicitationId,
      {
        solicitacaoId: surgerySolicitationId,
        medicoSolicitanteId: executantDoctorId,
      },
    )
    return APIResponse
  }

  @Action
  async deleteLaudo(params: any) {
    const request = await this.autorizacao.deleteLaudo(params.hospitalId, params.id)
    if (request.success) {
      this.context.commit('deleteLaudoById', params.id)
    }

    return request
  }

  @Action
  async uploadLaudoAnestesista(formData: any) {
    const { id } = this.solicitacao
    const headers: any = { 'Content-Type': 'multipart/form-data' }
    const request = await this.preAnestesia.upload(formData, TipoDocumentoUpload.LaudoAnestesista, headers, id)
    if (request.success) {
      const laudosCast = request.data
      this.context.commit('setLaudos', laudosCast)
    }
    return request
  }

  @Action
  async uploadCotacaoOperadora(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const cotacaoOpme = TipoDocumentoUpload.CotacaoOpme
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = await this.autorizacao.upload(formData, cotacaoOpme, header, solicitacaoId)

    return request
  }

  @Action
  async upload(params: any) {
    const solicitacaoId = params.solicitacaoId || this.solicitacao.id
    const { formData, tipoDocumento } = params
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = this.autorizacao.upload(formData, tipoDocumento, header, solicitacaoId)

    return request
  }

  @Action
  async closeModalPreAgendamento() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('setModal', { name: 'preAgendamento', value: false })
  }

  @Action
  async closeModalRevisaoCirurgica() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearSolicitacaoFromList')
    this.context.commit('setModal', { name: 'revisaoCirurgica', value: false })
  }

  @Action
  async closeModalRevisaoCirurgicaAutorizacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearSolicitacaoFromList')
    this.context.commit('setModal', { name: 'revisaoCirurgicaAutorizacao', value: false })
  }

  @Action
  async closeModalPendenciaAdministrativa() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearSolicitacaoFromList')
    this.context.commit('setModal', { name: 'pendenciaAdministrativa', value: false })
  }

  @Action
  async closeModalTriagem() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'triagem', value: false })
  }

  @Action
  async closeModalRegulacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'regulacao', value: false })
  }

  @Action
  async closeModalAtualizarAutorizacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'atualizarAutorizacao', value: false })
  }

  @Action
  async closeModalAguardandoCotacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'suprimentosAguardandoCotacao', value: false })
  }

  @Action
  async closeModalSuprimentosAguardandoCotacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'suprimentosCotacao', value: false })
  }

  @Action
  async closeModalAutorizada() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('clearAgendamentoConfirmarTriagem')
    this.context.commit('setModal', { name: 'autorizada', value: false })
  }

  @Action
  async closeModalIniciarProcesso() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('setModal', { name: 'iniciarProcesso', value: false })
  }

  @Action
  async closeModalAutorizarProcesso() {
    this.context.commit('clearSolicitacao')
    this.context.commit('setModal', { name: 'autorizarProcesso', value: false })
  }

  @Action
  async closeModalAguardandoNegociacaoParticular() {
    this.context.commit('clearSolicitacao')
    this.context.commit('setModal', { name: 'aguardandoNegociacaoParticular', value: false })
  }

  @Action
  async closeModalRealizarAvaliacao() {
    this.context.commit('clearSolicitacao')
    this.context.commit('clearNovaDataSolicitada')
    this.context.commit('clearReservaHemocomponentes')
    this.context.commit('setModal', { name: 'realizarAvaliacao', value: false })
  }

  @Action
  async closeModalPriorizar() {
    this.context.commit('clearSolicitacao')
    this.context.commit('setModal', { name: 'priorizar', value: false })
  }

  @Action
  async anestesistaFazAvaliacao(userId: string) {
    const anestesista: Anestesista = {
      alergiaLatex: this.solicitacao.alergiaLatex,
      especificarOutrasAlergias: this.solicitacao.especificarOutrasAlergias,
      observacaoPreAnestesia: this.solicitacao.observacaoPreAnestesia,
      outrasAlergias: this.solicitacao.outrasAlergias,
      pacienteApto: this.solicitacao.pacienteAptoParaAnestesia || false,
      reservaHemocomponentes: [],
      reservaUTI: this.solicitacao.reservaUtiTemp,
      solicitacaoId: this.solicitacao.id,
      pacienteUsaMarcaPasso: this.solicitacao.pacienteUsaMarcaPasso,
      historicoFamiliarHipertemiaMaligna: this.solicitacao.historicoFamiliarHipertemiaMaligna,
      classificacaoAsa: this.solicitacao.classificacaoAsa,
      tipoAnestesia: [],
      userId,
      viasAereasDificilAcesso: this.solicitacao.viasAereasDificilAcesso,
    }

    this.solicitacao.tipoAnestesiaTemp.map((c: string) => {
      if (c === 'Outros') {
        anestesista.tipoAnestesia.push({ outrosTipoAnestesia: this.solicitacao.outrosTipoAnestesia, tipoAnestesia: c })
      } else {
        anestesista.tipoAnestesia.push({ tipoAnestesia: c })
      }
      return c
    })

    const hemocomponentes: string[] = ['concentradoHemacias', 'concentradoPlaquetas', 'crioprecipitado', 'plasmaFrescoCongelado', 'tipagemSanguineaABORHPAI', 'semReserva']
    hemocomponentes.forEach((m) => {
      if (this.reservaHemocomponentes[m].value) {
        const reserva: ReservaHemocomponenteAnestesista = {
          quantidade: this.reservaHemocomponentes[m].quantidade,
          // @ts-ignore
          tipo: _.upperFirst(m),
        }
        anestesista.reservaHemocomponentes.push(reserva)
      }
    })

    const request = await this.preAnestesia.anestesistaFazAvaliacao(anestesista)
    return request.success
  }

  @Action
  async anestesistaSolicitaCancelamento() {
    const request = await this.preAnestesia.anestesistaSolicitaCancelamento(this.solicitacao.id)
    return request.success
  }

  @Action
  async autorizacaoAlteraCotacaoExtraGrupo() {
    const solicitacaoId: string = this.solicitacao.id
    const cotacaoOperadorasExtraGrupo = {
      cotacaoOperadorasExtraGrupo: this.solicitacao.cotacaoOperadorasExtraGrupo ? { ...this.solicitacao.cotacaoOperadorasExtraGrupo } : { ...this.cotacaoOperadorasExtraGrupoDefault },
    }

    const { observacao } = cotacaoOperadorasExtraGrupo.cotacaoOperadorasExtraGrupo || null
    if (observacao && observacao !== 'Pacote') cotacaoOperadorasExtraGrupo.cotacaoOperadorasExtraGrupo.valor = null

    const request = await this.autorizacao.autorizacaoAlteraCotacaoExtraGrupo(solicitacaoId, cotacaoOperadorasExtraGrupo)

    if (request.success) {
      return request.data
    }

    return false
  }

  @Action
  async enviarMensagem(params: any) {
    const action = this.contestacaoMedica.contestacaoId ? 'enviarMensagem' : 'abrirContestacao'
    const mensagem = action === 'enviarMensagem'
      ? { mensagens: [{ ...params.contestacaoMedicaMensagem }] }
      : [params.contestacaoMedicaMensagem]

    const request = await this.autorizacao[action](this.solicitacao.id, mensagem)
    if (request.success) {
      if (request.data && request.data.solicitacao) {
        const contestacao = await this.getContestacaoMedica(this.solicitacao.id)
        if (contestacao.success) {
          this.context.commit('setContestacaoMedica', contestacao.data)
        }
      } else {
        const { contestacaoMedicaMensagem } = params
        contestacaoMedicaMensagem.id = request.data.mensagens[0].id
        this.context.commit('setContestacaoMedicaMensagem', contestacaoMedicaMensagem)
      }
    }
    return request
  }

  @Action
  async uploadDocumentoContestacao(params: any) {
    const request = await this.autorizacao.uploadDocumentoContestacao(params.hospitalId, params.formData)
    return request
  }

  @Action
  async getContestacaoMedica(solicitacaoId: string) {
    this.context.commit('setSolicitacaoId', solicitacaoId)
    const request = await this.autorizacao.getContestacaoMedica(solicitacaoId)

    if (request.success) {
      this.context.commit('setContestacaoMedica', request.data)
    }
    return request
  }

  @Action
  async aceitarContestacao() {
    const request = await this.autorizacao.aceitarContestacao(this.solicitacao.id)
    return request
  }

  @Action
  async recusarContestacao() {
    const request = await this.autorizacao.recusarContestacao(this.solicitacao.id)
    return request
  }

  @Action
  async backofficeSuprimentosAvaliaMaterial(grupoOpmes: any) {
    const params: any = {
      grupoOpmes,
      solicitacaoId: this.solicitacao.id,
    }
    const response = await this.suprimentos.backofficeSuprimentosAvaliaMaterial(params)
    return response
  }


  @Action
  async backofficeSuprimentosAtualizaPrecificacaoOperadora(grupoOpmes: any) {
    const params: any = {
      grupoOpmes,
      solicitacaoId: this.solicitacao.id,
    }
    const response = await this.suprimentos.backofficeSuprimentosAtualizaPrecificacaoOperadora(params)
    return response
  }

  @Action
  async loadEquipamentos() {
    const request = await this.solicitacaoCirurgiaImp.getEquipamentos(this.solicitacao.id)

    if (request.success) {
      this.context.commit('setEquipamentos', request.data)
    }

    return request
  }

  @Action({ commit: 'setEquipamentoGruposApi' })
  async getEquipmentGroupByHospitalId(
    {
      hospitalId,
      searchText = '',
      hasHospitalFromNetwork = false,
    } : {
      hospitalId: string,
      searchText?: string,
      hasHospitalFromNetwork?: boolean,
    },
  ) {
    try {
      const APIRequest = await this.solicitacaoCirurgiaImp.getEquipamentoGrupoSearch(hospitalId, searchText)
      return APIRequest.success ? { data: APIRequest.data, hasHospitalFromNetwork } : []
    } catch (error) {
      return []
    }
  }

  @Action
  async getAlterarSolicitacaoEquipamentoGruposApiSearch(searchText: string) {
    const { hospitalId } = this.solicitacaoAlterada
    const request = await this.solicitacaoCirurgiaImp.getEquipamentoGrupoSearch(hospitalId, searchText)
    this.context.commit('setEquipamentoGruposApi', { data: request.data || [] })
    this.context.commit('updateSelectedEquipmentsApiToSolicitacaoAlterada')
  }

  @Action({})
  async deleteEquipamento(equipamento: Equipamento | EquipamentoGrupoDaSolicitacao) {
    const equipmentId = 'grupoEquipamentoId' in equipamento ? equipamento.grupoEquipamentoId : equipamento.id

    const request = await this.solicitacaoCirurgiaImp.deleteGrupoEquipamento(this.solicitacao.id, equipmentId as string)
    return request
  }

  @Action
  async deleteSurgerySolicitationEquipmentById({ surgerySolicitationId, equipmentId }: { surgerySolicitationId: string, equipmentId: string }) {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.deleteSurgerySolicitationEquipmentById(surgerySolicitationId, equipmentId)
    return request
  }

  @Action({})
  async postEquipamento(equipamento: EquipamentoGrupoChild) {
    const solicitacaoId = this.solicitacao.id
    const grupoEquipamentoId = equipamento.grupoEquipamentoId!
    const equipamentoId = equipamento.id

    const request = await this.solicitacaoCirurgiaImp.postEquipamento(solicitacaoId, { grupoEquipamentoId, equipamentoId })
    if (request.success) {
      return equipamento
    }

    return {}
  }

  // Grupos de equipamento com uma única opção são marcados como selecionados
  // automaticamente na tela (ver setEquipamentoGruposApi). Sem isto, o radio
  // aparece marcado mas o EquipamentoId nunca é gravado no backend.
  @Action
  async persistPendingAutoSelectedEquipamentos() {
    const pendentes = [...this.pendingAutoSelectedEquipamentos]
    this.context.commit('clearPendingAutoSelectedEquipamentos')

    await Promise.all(pendentes.map(equipamento => this.postEquipamento(equipamento)))
  }

  @Action
  async bloquearSolicitacao(solicitacaoId: string) {
    try {
      const request = await this.agendamento.bloquearSolicitacao(solicitacaoId)
      return request
    } catch (error) {
      return { message: 'Não foi possível bloquear a solicitação.' }
    }
  }

  @Action
  async desbloquearSolicitacao(solicitacaoId: string) {
    try {
      const request = await this.agendamento.desbloquearSolicitacao(solicitacaoId)
      this.context.commit('setGrupoOpmeApi', [])
      return request
    } catch (error) {
      this.context.commit('setGrupoOpmeApi', [])
      return { message: 'Não foi possível desbloquear a solicitação.' }
    }
  }

  @Action({ commit: 'setTemplate' })
  async getHospitalTemplate(hospitalId: string) {
    try {
      const request = await this.agendamento.getTemplateHospital(hospitalId)
      return request.success ? JSON.parse(request.data.template) : { formulario: {}, hospital: {}, porConvenio: [] }
    } catch (error) {
      return {}
    }
  }

  @Action
  async gerarGuias(data: any) {
    try {
      const params: any = { solicitacaoId: this.solicitacao.id, ...data }
      const request = await this.autorizacao.gerarGuias(params)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async backofficeSuprimentosConfirmaReservaDeMateriais(solicitacaoId: string) {
    try {
      const request = await this.suprimentos.backofficeSuprimentosConfirmaReservaDeMateriais(solicitacaoId)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getProcedimentosBackofficeSearch(searchText: string) {
    const { medicoSolicitanteId, hospitalId } = this.solicitacaoAlterada
    const { convenioId } = this.solicitacaoAlterada.paciente
    const request = await this.autorizacao.getProcedimentosBackofficeSearch(medicoSolicitanteId, hospitalId, convenioId, searchText)
    if (request.success) {
      this.context.commit('setProcedimentosApi', request)
      this.removeProcedimentosSelectedFromApi()
    }
    return request
  }

  @Action
  async deleteProcedimentoPrincipal(solicitacaoId: string) {
    try {
      const request = await this.autorizacao.deleteProcedimentoPrincipal(solicitacaoId)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteProcedimentoAssociado(procedimentoId: string) {
    try {
      const requestDelete = await this.autorizacao.deleteProcedimento(this.solicitacao.id, procedimentoId)
      if (requestDelete.success) {
        const requestSolicitacao = await this.context.dispatch('getSolicitacaoById', this.solicitacao.id)
        return requestSolicitacao.success
          ? requestSolicitacao
          : { success: false, message: 'Não foi possível remover o procedimento.' }
      }
      return { success: false, message: 'Não foi possível remover o procedimento.' }
    } catch (error) {
      return { success: false, message: 'Não foi possível remover o procedimento.' }
    }
  }

  @Action
  async postProcedimentoPrincipal(procedimentoPrincipal: any) {
    try {
      const requestDelete = await this.context.dispatch('deleteProcedimentoPrincipal', this.solicitacao.id)
      if (requestDelete.success) {
        const requestPost = await this.autorizacao.postProcedimentoPrincipal(this.solicitacao.id, procedimentoPrincipal)
        if (requestPost.success) {
          const requestSolicitacao = await this.context.dispatch('getSolicitacaoById', this.solicitacao.id)
          return requestSolicitacao
        }
        return { success: false, message: 'Não foi possível alterar o procedimento.' }
      }
      return { success: false, message: 'Não foi possível alterar o procedimento.' }
    } catch (error) {
      return { success: false, message: 'Não foi possível alterar o procedimento.' }
    }
  }

  @Action
  async postProcedimentoAssociado(procedimentoAssociado: any) {
    try {
      const requestPost = await this.autorizacao.postProcedimento(this.solicitacao.id, procedimentoAssociado)
      if (requestPost.success) {
        const requestSolicitacao = await this.context.dispatch('getSolicitacaoById', this.solicitacao.id)
        if (requestSolicitacao.success) {
          const { procedimentosAssociados } = requestSolicitacao.data
          if (procedimentosAssociados && procedimentosAssociados.length > 0) {
            procedimentosAssociados.forEach((e: any) => this.context.commit('removeFromProcedimentosApi', e.id))
          }
          return requestSolicitacao
        }
        return { success: false, message: 'Não foi possível adicionar o procedimento.' }
      }
      return { success: false, message: 'Não foi possível adicionar o procedimento.' }
    } catch (error) {
      return { success: false, message: 'Não foi possível adicionar o procedimento.' }
    }
  }

  @Action({ commit: 'setProcedimentosInternacao' })
  async getProcedimentosInternacaoBackofficeSearch(searchText: string) {
    try {
      const request = await this.autorizacao.getProcedimentosInternacaoBackofficeSearch(this.solicitacao.hospitalId, searchText)
      return request.success ? await this.forceCast<Procedimento[]>(request.data) : []
    } catch (error) {
      return []
    }
  }

  @Action
  async postProcedimentoBackoffice(procedimento: any) {
    try {
      const request = await this.autorizacao.postProcedimentoBackoffice(this.solicitacao.id, procedimento)
      if (request.success) this.context.commit('addProcedimentosInternacaoSelected', procedimento)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteProcedimentoBackoffice(procedimentoId: string) {
    try {
      const request = await this.autorizacao.deleteProcedimentoBackoffice(this.solicitacao.id, procedimentoId)
      if (request.success) this.context.commit('removeProcedimentosInternacaoSelected', procedimentoId)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getAllConvenios(hospitalId: string) {
    const request = await this.agendamento.getAllConvenio(hospitalId)
    if (request.success) this.context.commit('setConvenios', request.data)
    return request
  }

  @Action
  async getHealthInsuranceById({ hospitalId, healthInsuranceById }) {
    const healthInsuranceAPIRequest = await this.agendamento.getConvenioById({
      hospitalId,
      convenioId: healthInsuranceById,
    })

    if (healthInsuranceAPIRequest.success) {
      this.context.commit('setHealthInsuranceData', healthInsuranceAPIRequest.data)
    }

    return healthInsuranceAPIRequest
  }

  @Action
  async getAllPlanos(params: any) {
    const { hospitalId, convenioId } = params
    const request = await this.agendamento.getAllPlanos(hospitalId, convenioId)
    if (request.success) this.context.commit('setPlanos', request.data)
    return request
  }

  @Action
  async getAllCategoriasByConvenio(params: any) {
    try {
      const response = await this.agendamento.getAllCategoriasByConvenio(params)
      if (response.success) this.context.commit('setCategorias', response.data)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  // Somente para a Modal Alterar Solicitação...
  @Action
  async getAllCategoriasByPlano(params: any) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllCategoriasByPlano(params)
      this.context.commit('setCategorias', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setCategorias', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action({ commit: 'setHospitais' })
  async getAllHospitais() {
    const request = await this.autorizacao.getHospitalCurrentUser()
    if (request.success) return request.data
    return []
  }

  @Action
  async atualizarOrcamento(acaoDoUsuario: string) {
    const solicitacao = await this.obterSolicitacaoParaAtualizacao()
    const payload = Object.assign({}, solicitacao, { acaoDoUsuario })
    return this.agendamento.backofficeAtualizarOrcamento(payload)
  }

  @Action
  async obterSolicitacaoParaAtualizacao() {
    const { solicitacaoAlterada } = this

    Object.entries(solicitacaoAlterada).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) {
        delete solicitacaoAlterada[key]
      }

      if (key === 'solicitacaoProcedimentoInternacao') {
        if (!solicitacaoAlterada[key].procedimentoInternacaoId) {
          delete solicitacaoAlterada[key]
        }
      }
    })

    Object.entries(solicitacaoAlterada.paciente).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete solicitacaoAlterada.paciente[key]
    })

    if (solicitacaoAlterada.dadosGestacionais && typeof solicitacaoAlterada.dadosGestacionais === 'object') {
      if (['', null, undefined].includes(solicitacaoAlterada.dadosGestacionais.idadeGestacional)) {
        delete solicitacaoAlterada.dadosGestacionais.idadeGestacional
      }
      if (![true, false].includes(solicitacaoAlterada.dadosGestacionais.gemelar)) {
        delete solicitacaoAlterada.dadosGestacionais.gemelar
      }
      if (Object.keys(solicitacaoAlterada.dadosGestacionais).length === 0) {
        delete solicitacaoAlterada.dadosGestacionais
      }
    }

    const params: any = { ...solicitacaoAlterada }
    params.procedimentos = formatProcedimentosUpdateSolicitacao([{ ...params.procedimento }])
    delete params.procedimento
    if (params.procedimentosAssociados) {
      params.procedimentos = [...params.procedimentos, ...formatProcedimentosUpdateSolicitacao(params.procedimentosAssociados)]
      delete params.procedimentosAssociados
    }
    if (params.procedimentosInternacao) {
      params.procedimentos = [...params.procedimentos, ...formatProcedimentosUpdateSolicitacao(params.procedimentosInternacao)]
      delete params.procedimentosInternacao
    }
    if (params.grupoOpmeDaSolicitacao) {
      params.grupoOpmeIds = params.grupoOpmeDaSolicitacao.map((e: any) => e.id).filter((e: string) => e)
    }
    if (params.equipamentos) {
      const equipamentos: Array<{ grupoEquipamentoId: string, equipamentoId?: string }> = []
      params.equipamentos.forEach((grupoEquipamento) => {
        equipamentos.push({ grupoEquipamentoId: grupoEquipamento.id })
      })
      params.equipamentos = equipamentos
    }
    const { grupoOpmeDaSolicitacao, solicitacaoId } = solicitacaoAlterada
    const opmesApagados = getOpmesApagados(
      JSON.parse(JSON.stringify(this.grupoOpmeDaSolicitacao)),
      grupoOpmeDaSolicitacao,
      solicitacaoId,
    ) || []
    if (opmesApagados.length > 0) {
      const promises = opmesApagados.map(async (opme: any, index: number) => {
        await this.context.dispatch('deleteGrupoOpmeDaSolicitacaoOpme', opme)
      })
      await Promise.all(promises)
    }

    // Força o valor SemReserva para a reserva de UTI quando o procedimento for ambulatorial...
    if (
      opcaoHabilitadoShared(this.template, 'formularioMedico', 'limparReservaUtiNoTipoDeInternacaoAmbulatorial')
      && opcaoHabilitadoShared(this.template, 'tipoProcedimento', 'ambulatorial')
      && opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')
    ) {
      if (params.tipoProcedimento === 'Ambulatorial') {
        if (opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')) params.reservaUTI = 'SemReserva'
        if (opcaoHabilitadoShared(this.template, 'reservaUti', 'reservaUtiNao')) params.reservaUTI = 'ReservaUtiNao'
        if (params.diariaUti) params.diariaUti = null
        if (params.diaria) params.diaria = null
      }
    }

    if (opcaoHabilitadoShared(this.template, 'tipoProcedimento', 'hospitalDia') && this.todosProcedimentosHospitalDia) {
      if (opcaoHabilitadoShared(this.template, 'reservaUti', 'semReservaUti')) params.reservaUTI = 'SemReserva'
      if (opcaoHabilitadoShared(this.template, 'reservaUti', 'reservaUtiNao')) params.reservaUTI = 'ReservaUtiNao'
      if (params.diariaUti) params.diariaUti = 0
      if (params.diaria) params.diaria = 1
    }

    if (typeof params.lateralidade === 'object' && params.lateralidade !== null) delete params.lateralidade
    if (typeof params.reservaUTI === 'object' && params.reservaUTI !== null) delete params.reservaUTI

    // Última limpeza do objeto params...
    Object.entries(params).forEach(([key, value]) => {
      if (['', null, undefined].includes(value as any)) delete params[key]
    })

    if (params.honorarioAnestesistaEnum) params.honorarioAnestesista = params.honorarioAnestesistaEnum

    return params
  }

  @Action
  async backofficeAgendamentoAtualizaSolicitacao() {
    const payload = await this.obterSolicitacaoParaAtualizacao()
    const response = await this.agendamento.backofficeAgendamentoAtualizaSolicitacao(payload)
    return response
  }

  @Mutation
  removerOpmeDoGrupoOpmeDaSolicitacao({ grupoOpmeId, opmeId }) {
    const grupoOpme = this.solicitacaoAlterada.grupoOpmeDaSolicitacao.find((grupo: any) => grupo.id === grupoOpmeId)
    const { opmes } = grupoOpme
    opmes.splice(opmes.findIndex((opme: any) => opme.opmeId === opmeId), 1)
    if (opmes && opmes.length === 0) {
      const { grupoOpmeDaSolicitacao } = this.solicitacaoAlterada
      grupoOpmeDaSolicitacao.splice(grupoOpmeDaSolicitacao.findIndex((grupo: any) => grupo.id === grupoOpmeId), 1)
    }
  }

  @Action
  async removerOpmeDoGrupo(params: any) {
    await timeout(500)
    this.context.commit('removerOpmeDoGrupoOpmeDaSolicitacao', params)
  }

  @Action
  async getMedicoDoHisById() {
    try {
      const params: any = {
        hospitalId: this.solicitacao.hospitalId,
        hisId: this.medicoDoHis.hisId,
      }
      const request = await this.agendamento.getMedicoByHisId(params)
      if (request.success) this.context.commit('setMedicoDoHis', request.data as MedicoDoHis)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async backofficeAgendamentoResolvePendenciaMedico() {
    try {
      const params: any = {
        solicitacaoId: this.solicitacao.id,
        hisId: this.medicoDoHis.hisId,
      }
      const request = await this.agendamento.backofficeAgendamentoResolvePendenciaMedico(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async backofficeAgendamentoAtualizaPaciente(paciente: any) {
    const params: any = {
      solicitacaoId: this.solicitacao.id,
      paciente: { ...paciente },
      adicionaPacienteNoHis: this.atualizaPaciente,
    }
    const response = await this.agendamento.backofficeAgendamentoResolvePendenciaDePacienteNoHis(params)
    return response
  }

  @Action
  async backofficeAgendamentoAdicionarPaciente(params: { solicitacaoId: string, adicionaPacienteNoHis: boolean, paisId?: string }) {
    try {
      const response = await this.agendamento.backofficeAgendamentoResolvePendenciaDePacienteNoHis(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getSolicitacaoAlteradaById(solicitacaoId: string) {
    try {
      const params: any = { solicitacaoId }
      const response = await this.agendamento.getSolicitacaoById(params)
      if (response.success) this.context.commit('setSolicitacaoAlterada', response.data)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async backofficeAgendamentoRemoveEquipamento(index: number) {
    this.solicitacaoAlterada.equipamentos.splice(index, 1)
  }

  /**
   * ÁREA DE OPME
   */

  public opmeDefault: any = {
    opme: null,
    quantidade: 0,
    possuiGrade: false,
    observacao: null,
    fornecedor1Id: '',
    fornecedor2Id: '',
    fornecedor3Id: '',
    fornecedor1: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
    fornecedor2: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
    fornecedor3: {
      fabricante: '',
      fornecedorId: '',
      homologadoConvenio: false,
      homologadoHospital: false,
      nome: '',
    },
  }

  public habilitarGrade: boolean = false
  public grupoOpmeDefault: GrupoOpme = {
    medicoId: '',
    descricao: '',
    justificativa: '',
    procedimentoId: '',
    solicitacaoId: '',
    opmes: [this.opmeDefault],
    id: '',
    procedimentoCodigo: '',
    tipo: '',
  }

  private novoFornecedorDefault: NovoFornecedor = {
    nomeFornecedor: '',
    nomeFabricante: '',
    medicoId: '',
    hospitalId: '',
    contato: '',
  }

  private novoOPMEDefault: NovoOPME = {
    medicoId: '',
    descricao: '',
    possuiGrade: false,
  }

  public grupoOpmeDaSolicitacao: GrupoOpme[] = []
  public opme: any = { ...this.opmeDefault }
  private opmeGrupoDefault: any[] = [this.opme]
  public opmeGrupo: any[] = [...this.opmeGrupoDefault]
  public opmeGrupoInicial: any[] = []
  public opmeGrupoId: string = ''
  private listaMedicoOpmeDefault: any[] = []
  public listaMedicoOpme: any[] = [...this.listaMedicoOpmeDefault]
  public solicitacaoMaterialOptions: MaterialOptions[] = []
  public novoFornecedor: NovoFornecedor = { ...this.novoFornecedorDefault }
  public medicoGrupoOpmes: GrupoOpme[] = []
  public fornecedores: FornecedorOPME[] = []
  public grupoOpme: GrupoOpme = { ...this.grupoOpmeDefault }
  public novoOPME: NovoOPME = { ...this.novoOPMEDefault }
  private materialOpmeDefault: any = {
    opmeId: '',
    quantidade: '',
    gradeCompleta: false,
  }

  public materiaisOpme: any[] = [{ ...this.materialOpmeDefault }]

  @Mutation
  setOpmeGrupoId(value: string) {
    this.opmeGrupoId = value
  }

  @Mutation
  clearOpmeGrupoId() {
    this.opmeGrupoId = ''
  }

  @Mutation
  clearOpmeGrupoInicial() {
    this.opmeGrupoInicial = []
  }

  @Mutation
  adicionarItemOPME() {
    this.opmeGrupo.push({ ...this.opmeDefault })
    this.fornecedores.map((e: any) => {
      const c = e
      c.disabled = false
      return c
    })
  }

  @Mutation
  removeItemOPME(index: number) {
    if (this.opmeGrupo.length === 1) return
    const opmeId = this.opmeGrupo[index].opme ? this.opmeGrupo[index].opme.id : ''
    const opme = this.listaMedicoOpme.find((e: any) => e.id === opmeId)
    if (opme) opme.disabled = false
    this.opmeGrupo.splice(index, 1)
  }

  @Mutation
  resetOPMEGrupo() {
    this.opmeGrupo = [...this.opmeGrupoDefault]
  }

  @Mutation
  FornecedorDisabledChange(opmeFornecedor: any) {
    this.fornecedores.map((e: any) => {
      const r = e
      r.disabled = (r.fornecedorId === this.grupoOpme[opmeFornecedor.index].fornecedor1Id
        || r.fornecedorId === this.grupoOpme[opmeFornecedor.index].fornecedor2Id
        || r.fornecedorId === this.grupoOpme[opmeFornecedor.index].fornecedor3Id)
      return r
    })
  }

  @Mutation
  enableOPMEs(opmeEdit: any) {
    const ids = opmeEdit.opmes.map((e: any) => {
      const { id } = e.opme
      return id
    })

    this.listaMedicoOpme.map((e: any) => {
      const opme = e
      opme.disabled = ids.includes(opme.id)
      return opme
    })
  }

  @Mutation
  enableFornecedores() {
    this.fornecedores.map((e: any) => {
      const f = e
      f.disabled = false
      return f
    })
  }

  @Mutation
  setOpmeGrupo(value: any) {
    const opmes = value.opmes.map((e: any) => ({
      opme: e.opme,
      quantidade: e.quantidade,
      possuiGrade: e.opme.possuiGrade,
      observacao: e.observacao,
      fornecedor1Id: e.fornecedor1Id,
      fornecedor2Id: e.fornecedor2Id,
      fornecedor3Id: e.fornecedor3Id,
    }))

    this.opmeGrupo = opmes
    this.opmeGrupoInicial = setOPMEsToSave(opmes)
  }

  @Mutation
  adicionarOpmeDefault() {
    const opme: GrupoOpmes = {
      gradeCompleta: false,
      opme: {
        descricao: '',
        id: '',
        possuiGrade: false,
      },
      opmeId: '',
      quantidade: 0,
    }

    this.grupoOpme.opmes.push(opme)
  }

  @Mutation
  setListaMedicoOpme(value: any[]) {
    this.listaMedicoOpme = value
    this.solicitacaoMaterialOptions = value.map(elem => ({ ...elem }))
  }

  @Action
  materialChange(data: { opme: OpmeMaterial, index: number }) {
    const { opme, index } = data

    this.solicitacaoAlterada.grupoDeOpme!.opmes[index].id = opme.id
    this.solicitacaoAlterada.grupoDeOpme!.opmes[index].descricao = opme.descricao

    this.context.commit('updateSolicitacaoMaterialOptions')
  }


  @Mutation
  updateSolicitacaoMaterialOptions() {
    backofficeSharedDataService.materialOptions.forEach((opme) => {
      const findIndex = this.solicitacaoAlterada.grupoDeOpme!.opmes.findIndex(elem => elem.id === opme.id)
      if (findIndex !== -1) {
        // eslint-disable-next-line
        opme.disabled = true
      } else {
        // eslint-disable-next-line
        opme.disabled = false
      }
    })
  }

  @Action
  adicionarOpme() {
    this.solicitacaoAlterada.grupoDeOpme!.opmes.push({} as any)
    this.context.commit('updateSolicitacaoMaterialOptions')
  }

  @Action
  deleteOpme(index: number) {
    this.solicitacaoAlterada.grupoDeOpme!.opmes.splice(index, 1)
    this.context.commit('updateSolicitacaoMaterialOptions')
  }

  @Mutation
  clearListaMedicoOpme() {
    this.listaMedicoOpme = [...this.listaMedicoOpmeDefault]
  }

  @Mutation
  adicionarCamposDefault() {
    this.materiaisOpme.push({ ...this.materialOpmeDefault })
  }

  @Mutation
  setHabilitarGrade(value: boolean) {
    this.habilitarGrade = value
  }

  @Mutation
  setGrupoOpmes(value: any[]) {
    this.grupoOpme.opmes = value
  }

  @Mutation
  setGrupoOpme(value: any) {
    this.grupoOpme = value
  }

  @Mutation
  deleteOpmes(index: number) {
    this.grupoOpme.opmes.splice(index, 1)
  }

  @Mutation
  deleteOpmeFromGrupoOpme(params: any) {
    const grupoOpme = this.grupoOpmeDaSolicitacao.find((e: GrupoOpme) => e.id === params.grupoOpmeDaSolicitacaoId)
    // @ts-ignore
    const index = grupoOpme.opmes.findIndex((c: any) => c.opmeId === params.opmeId)
    // @ts-ignore
    grupoOpme.opmes.splice(index, 1)
  }

  @Mutation
  clearNovoFornecedor() {
    this.novoFornecedor = { ...this.novoFornecedorDefault }
  }

  @Mutation
  setGrupoOpmeDaSolicitacao(grupoOpmeDaSolicitacao: GrupoOpme[]) {
    this.grupoOpmeDaSolicitacao = grupoOpmeDaSolicitacao
  }

  @Mutation
  clearGrupoOpmeDaSolicitacao() {
    this.grupoOpmeDaSolicitacao = []
  }

  @Mutation
  setGrupoOpmeDaSolicitacaoItem(grupoOpmeDaSolicitacao: GrupoOpme) {
    this.grupoOpmeDaSolicitacao.push(grupoOpmeDaSolicitacao)
  }

  @Mutation
  setMedicoGrupoOpmes(grupoOpmes: any[]) {
    this.medicoGrupoOpmes = grupoOpmes
  }

  @Mutation
  clearMedicoGrupoOpmes() {
    this.medicoGrupoOpmes = []
  }

  @Mutation
  setFornecedores(fornecedores: FornecedorOPME[]) {
    this.fornecedores = fornecedores
  }

  @Mutation
  opmeEnabled(opmeId: string) {
    this.listaMedicoOpme.map((c) => {
      const e = c
      if (e.id === opmeId) {
        e.disabled = true
      }
      return e
    })
  }

  @Mutation
  opmeDisabledChangeOnDelete() {
    this.listaMedicoOpme.map((c) => {
      const e = c
      e.disabled = this.grupoOpme.opmes.some(d => d.opme.id === e.id)
      return e
    })
  }

  @Mutation
  fornecedorDisabledChange() {
    this.fornecedores.map((e: any) => {
      const r = e
      r.disabled = (r.fornecedorId === this.grupoOpme.fornecedor1Id
        || r.fornecedorId === this.grupoOpme.fornecedor2Id
        || r.fornecedorId === this.grupoOpme.fornecedor3Id)
      return r
    })
  }

  @Mutation
  setOpmeIdChange() {
    this.grupoOpme.opmes.map((d) => {
      const e = d
      e.opmeId = e.opme.id
      return e
    })
  }

  @Mutation
  clearFornecedores() {
    this.fornecedores = []
  }

  @Mutation
  async clearFornecedor(fornecedor: any) {
    const fr = this.fornecedores.find((e: any) => e.fornecedorId === this.opmeGrupo[fornecedor.index][fornecedor.fornecedorId])
    // @ts-ignore
    fr.disabled = false
    await timeout(100)
    this.opmeGrupo[fornecedor.index][fornecedor.fornecedorId] = ''
    // this.grupoOpme[fornecedorId] = ''
  }

  @Mutation
  clearGrupoOpme() {
    this.grupoOpme = { ...this.grupoOpmeDefault }
    this.grupoOpme.opmes = [{ quantidade: 0, opmeId: '', opme: { possuiGrade: false, id: '', descricao: '' }, gradeCompleta: false }]
  }

  @Mutation
  clearNovoOPME() {
    this.novoOPME = { ...this.novoOPMEDefault }
  }

  @Action
  async postFornecedor() {
    const fornecedor = {
      ...this.novoFornecedor,
      medicoId: this.solicitacaoAlterada.medicoSolicitanteId,
      hospitalId: this.solicitacaoAlterada.hospitalId,
      nomeFabricante: [null, undefined, ''].includes(this.novoFornecedor.nomeFabricante) ? '' : this.novoFornecedor.nomeFabricante,
      contato: formatPhoneMask(this.novoFornecedor.contato),
    }

    const response = await this.autorizacao.postForncecedor(fornecedor)

    if (response.success) {
      if (!this.solicitacaoAlterada.id) {
        await backofficeSharedDataService.loadFornecedorOptions()
      } else {
        this.context.dispatch('loadFornecedores')
      }
      this.context.commit('clearNovoFornecedor')
    }
    return response
  }

  @Action({ commit: 'setFornecedores' })
  async loadFornecedores() {
    const { hospitalId, medicoSolicitanteId, solicitacaoId } = this.solicitacaoAlterada
    const convenioId = this.solicitacaoAlterada.paciente.convenioId || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
    const request = await this.solicitacaoCirurgiaImp.getAllFornecedor(hospitalId, convenioId, medicoSolicitanteId, solicitacaoId)
    return request.success ? request.data : []
  }

  @Action({ commit: 'setFornecedores' })
  async getFornecedoresFromApi(solicitacao: string = 'solicitacao') {
    const { hospitalId, medicoSolicitanteId, id, solicitacaoId } = this[solicitacao]
    const convenioId = this.solicitacao.paciente.convenioId || 'e8496173-7c9d-43b2-9f01-4d490d69042b'
    const request = await this.solicitacaoCirurgiaImp.getAllFornecedor(hospitalId, convenioId, medicoSolicitanteId, id || solicitacaoId)
    return request.success ? request.data : []
  }

  @Action({ commit: 'setGrupoOpmeDaSolicitacao' })
  async loadOpmes() {
    const { solicitacaoId } = this.solicitacaoAlterada
    const request = await this.solicitacaoCirurgiaImp.getOpmes(solicitacaoId)

    if (request.success) return request.data.grupoOpmeDaSolicitacao
    return []
  }

  @Action
  async createNovoOPME() {
    const params = {
      hospitalId: this.solicitacaoAlterada.hospitalId,
      medicoId: this.solicitacaoAlterada.medicoSolicitanteId,
      descricao: this.novoOPME.descricao,
      possuiGrade: this.novoOPME.possuiGrade,
    }

    try {
      const request = await this.solicitacaoCirurgiaImp.createMedicoOpme(params)
      if (request.success) {
        if (!this.solicitacaoAlterada.id) {
          await backofficeSharedDataService.loadMaterialOptions()
        } else {
          this.context.dispatch('getMedicoOpme')
        }
      }
      return request.success
    } catch (error) {
      return false
    }
  }

  @Action({ commit: 'setListaMedicoOpme' })
  async getMedicoOpme() {
    try {
      const request = await this.solicitacaoCirurgiaImp.getMedicoOpme(this.solicitacaoAlterada.hospitalId, this.solicitacaoAlterada.medicoSolicitanteId, this.solicitacaoAlterada.solicitacaoId)
      return request.success ? request.data.opmes : []
    } catch (error) {
      return []
    }
  }

  @Action({ commit: 'setProtocoloOPMEsApi', rawError: true })
  async getOpmeSearch(params: any) {
    const { medicoSolicitanteId, hospitalId } = this.solicitacao
    const { convenioId } = this.solicitacao.paciente
    const procedimentosTemp: string[] = []
    procedimentosTemp.push(params.procedimentoPrincipalId)
    // @ts-ignore
    this.procedimentosAssociados.map(p => procedimentosTemp.push(p.id))

    const request = await this.solicitacaoCirurgiaImp
      .getOpmeSearch(medicoSolicitanteId, params.searchText, procedimentosTemp, convenioId || '', hospitalId)

    if (request) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setMedicoGrupoOpmes', rawError: true })
  async getGrupoOpmeByMedico(codigoProcedimentos: any[]) {
    try {
      const request = await this.solicitacaoCirurgiaImp.getGrupoOpmeByMedico(this.solicitacaoAlterada.hospitalId, this.solicitacaoAlterada.medicoSolicitanteId, this.solicitacaoAlterada.solicitacaoId, codigoProcedimentos)
      return request.success ? request.data.grupoOpmes : []
    } catch (error) {
      return []
    }
  }

  @Action
  async createMedicoGrupoOpme(params: GrupoOpme) {
    try {
      const response = await this.solicitacaoCirurgiaImp.createMedicoGrupoOpme({ hospitalId: this.solicitacaoAlterada.hospitalId, ...params })
      return response
    } catch (error) {
      return { message: error }
    }
  }

  // !!! REFATORAR !!!
  @Action
  async deleteGrupoOpmeDaSolicitacaoOpme(params: any) {
    // const response = await this.solicitacaoCirurgiaImp.deleteGrupoOpmeDaSolicitacaoOpme(params)
    // if (response.success) {
    //   this.context.commit('deleteOpmeFromGrupoOpme', params)
    // }

    // const grupoOpmeDaSolicitacao = this.grupoOpmeDaSolicitacao.find((e: any) => e.id === params.grupoOpmeDaSolicitacaoId)
    // if (grupoOpmeDaSolicitacao && grupoOpmeDaSolicitacao.opmes.length === 0) {
    //   await this.context.dispatch('deletarOPMEdoGrupoOPME', { solicitacaoId: this.solicitacao.id, grupoOpmeDaSolicitacaoId: grupoOpmeDaSolicitacao.id })
    // }

    // return response
  }

  @Action
  async deletarOPMEdoGrupoOPME(params: any) {
    const response = await this.solicitacaoCirurgiaImp.deleteGrupoOpmeDaSolicitacao(params)
    if (response.success) {
      this.context.commit('deleteOpme', params.grupoOpmeDaSolicitacaoId)
    }
    return response
  }

  @Action
  async deleteDeleteGrupoOpmeDaSolicitacao(grupoOpmeId: string) {
    const params: any = {
      solicitacaoId: this.solicitacaoAlterada.solicitacaoId,
      grupoOpmeDaSolicitacaoId: grupoOpmeId,
    }

    const response = await this.solicitacaoCirurgiaImp.deleteGrupoOpmeDaSolicitacao(params)
    if (response.success) {
      this.context.commit('deleteOpme', grupoOpmeId)
    }
    return response
  }

  @Action
  async updateProcedimentoBySolicitacaoId(procedimento: any) {
    try {
      const response = await this.solicitacaoCirurgiaImp.updateProcedimentoBySolicitacaoId({ solicitacaoId: this.solicitacao.id, ...procedimento })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async updateGrupoOpmeDaSolicitacao(params: any) {
    try {
      const response = await this.autorizacao.updateGrupoOpmeDaSolicitacao(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async backofficeAgendamentoDesfazCancelamento(params: any) {
    try {
      const request = await this.agendamento.backofficeAgendamentoDesfazCancelamento(params)
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getPrecaucoesFromTasy() {
    await timeout(2000)
    return { success: false, message: 'Tem precauções no Tasy, seu energúmeno!' }
  }

  @Action
  async getPowerBiEmbeddedInfo({ reportId, hospitalId, redeId }: { reportId: string, hospitalId?: string, redeId?: string }) {
    try {
      const request = await this.agendamento.getPowerBiEmbeddedInfo(reportId, hospitalId, redeId)
      if (request.success) {
        this.context.commit('setEmbeddedInfo', request.data)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getPowerBiReportTypes() {
    try {
      const request = await this.agendamento.getPowerBiReportTypes()
      if (request.success) {
        const { relatorios: reports, corporativo: corporate } = request.data

        this.context.commit('setPowerBiReportTypes', reports)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getHospitalSurgeryCenter({ hospitalId, itemsPerPage }) {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllCentrosCirurgicosByHospital({ hospitalId, qtdPorPagina: itemsPerPage })
      if (request.success) {
        const { centrosCirurgicos: surgeryCenters } = request.data

        this.context.commit('setHospitalSurgeryCenters', surgeryCenters)
      }

      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getHospitalsCurrentUser() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalCurrentUser()
      if (request.success) {
        this.context.commit('setHospitalsCurrentUser', request.data)
      }
      return request
    } catch (error) {
      return { success: false }
    }
  }

  @Mutation
  setPowerBiReportTypes(value: PowerBiReportType[]) {
    this.powerBiReportTypes = value
  }

  @Mutation
  setHospitalsCurrentUser(value: { id: string, nome: string }[]) {
    this.hospitalsCurrentUser = value
  }

  @Mutation
  setHospitalSurgeryCenters(value: { id: string, nome: string }[]) {
    this.hospitalsSurgeryCenters = value
  }

  @Mutation
  updateValorNegociadoNoHis(grupoDeValores: any) {
    const grupoDeValoresId = grupoDeValores.map((g: any) => g.id)
    this.solicitacao.grupoOpmeDaSolicitacao.map((grupo: any) => {
      const grp = grupo
      if (grupoDeValoresId.includes(grp.id)) {
        const { opmes } = grupoDeValores.find((g: any) => g.id === grp.id)
        const opmesDaSolicitacao = grp.opmes
        opmesDaSolicitacao.map((opme: any) => {
          const op = opme
          const opm = opmes.find((o: any) => o.opmeId === op.opmeId)
          if (opm) op.valorNegociado = opm.valorNegociado
          if (op.valorUnitario === 0) op.valorUnitario = opm.valorNegociado
          return op
        })
      }
      return grp
    })
  }

  @Action
  async consultaValorNegociadoNoHis(grupo: any) {
    try {
      const request = await this.agendamento.consultaValorNegociadoNoHis({ solicitacaoId: this.solicitacao.id, grupoOpmes: grupo })
      if (request.success) {
        this.context.commit('updateValorNegociadoNoHis', request.data.grupoOpmeDaSolicitacao || [])
        return request
      }
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }


  /**
   * Caixas cirúrgicas
   */
  private caixasCirurgicasApiDefault: CaixaCirurgica[] = []
  public caixasCirurgicasApi: CaixaCirurgica[] = [...this.caixasCirurgicasApiDefault]

  @Mutation
  setCaixasCirurgicasApi(caixasCirurgicas: CaixaCirurgica[]) {
    if (this.solicitacao.caixasCirurgicas.length > 0) {
      Object.entries(this.solicitacao.caixasCirurgicas).forEach(([key, value]) => {
        const index = caixasCirurgicas.findIndex((c: CaixaCirurgica) => c.id === value.id)
        if (![undefined, -1].includes(index)) caixasCirurgicas.splice(index, 1)
      })
    }

    this.caixasCirurgicasApi = caixasCirurgicas
  }

  @Mutation
  clearCaixasCirurgicasApi() {
    this.caixasCirurgicasApi = [...this.caixasCirurgicasApiDefault]
  }

  @Mutation
  addCaixaCirurgicaToSolicitacao(caixaCirurgica: CaixaCirurgica) {
    const index = this.solicitacao.caixasCirurgicas.findIndex((c: CaixaCirurgica) => c.id === caixaCirurgica.id)
    if (![undefined, -1].includes(index)) {
      this.solicitacao.caixasCirurgicas[index] = { ...caixaCirurgica }
    } else {
      this.solicitacao.caixasCirurgicas.push(caixaCirurgica)
    }
  }

  @Mutation
  removeCaixaCirurgicaFromSolicitacao(id: string) {
    const index = this.solicitacao.caixasCirurgicas.findIndex((caixaCirurgica: CaixaCirurgica) => caixaCirurgica.id === id)
    this.solicitacao.caixasCirurgicas.splice(index, 1)
  }

  @Mutation
  removeItemFromCaixaCirurgicaApi(id: string) {
    this.caixasCirurgicasApi.splice(this.solicitacao.caixasCirurgicas.findIndex((caixaCirurgica: CaixaCirurgica) => caixaCirurgica.id === id), 1)
  }

  @Action
  async getAllCaixasCirurgicasByHospitalId(searchText: string = '') {
    try {
      const params = { searchText, hospitalId: this.solicitacao.hospitalId }
      const request = await this.solicitacaoCirurgiaImp.getAllCaixasCirurgicasByHospitalId(params)
      if (request.success) this.context.commit('setCaixasCirurgicasApi', request.data as CaixaCirurgica[] || [])
      return request
    } catch (error) {
      this.context.commit('setCaixasCirurgicasApi', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertCaixaCirurgicaBySolicitacaoId(caixaCirurgica: any) {
    try {
      const request = await this.solicitacaoCirurgiaImp.upsertCaixaCirurgicaBySolicitacaoId({
        ...caixaCirurgica,
        solicitacaoId: this.solicitacao.id,
      })
      if (request.success) {
        this.context.commit('removeItemFromCaixaCirurgicaApi', caixaCirurgica.id)
        this.context.commit('addCaixaCirurgicaToSolicitacao', request.data as CaixaCirurgica)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteCaixaCirurgicaBySolicitacaoId(id: string) {
    try {
      const params: any = { id, solicitacaoId: this.solicitacao.id }
      const request = await this.solicitacaoCirurgiaImp.deleteCaixaCirurgicaBySolicitacaoId(params)
      if (request.success) {
        this.context.commit('removeCaixaCirurgicaFromSolicitacao', id)
        this.context.dispatch('getAllCaixasCirurgicasByHospitalId')
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
  /** */

  /** Anestesistas */
  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 10
  public totalAnestesistas: number = 0
  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public anestesistaSearchText: string = ''

  @Mutation
  setAnestesistaSearchText(value: string) {
    this.anestesistaSearchText = value
  }

  @Mutation
  setTotalAnestesistas(value: number) {
    this.totalAnestesistas = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  clearPagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  public anestesistas: AnestesistaHospital[] = []

  @Mutation
  setAnestesistas(value: AnestesistaHospital[]) {
    this.anestesistas = value
  }

  @Mutation
  clearAnestesistas() {
    this.anestesistas = []
  }

  @Mutation
  setSolicitacaoAnestesista(value: AnestesistaHospital | null) {
    this.solicitacao.anestesista = value
  }

  @Action
  async getAllAnestesistasByHospitalId() {
    try {
      const { pagina, qtdPorPagina } = this
      const hospitalId = this.solicitacao.hospitalId || this.solicitacaoAlterada.hospitalId
      const request = await this.solicitacaoCirurgiaImp.getAllAnestesistasByHospitalId({
        hospitalId,
        searchText: this.anestesistaSearchText,
        pagina,
        qtdPorPagina,
      })
      if (request.success) {
        this.context.commit('setAnestesistas', request.data.anestesistas as AnestesistaHospital[] || [])
        this.context.commit('setTotalAnestesistas', request.data.total as number || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setAnestesistas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async resolvePendenciaDeAnestesista(params: any) {
    const solicitacaoId = this.solicitacao.id || this.solicitacaoAlterada.id

    try {
      const payload: any = {
        solicitacaoId,
        anestesistaId: params.anestesistaId,
      }

      const request = await this.agendamento.resolvePendenciaDeAnestesista(payload)
      if (request.success) {
        await this.context.dispatch('getSolicitacaoById', solicitacaoId)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async gerarPedidoSemAssinatura(solicitacaoId: string) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.gerarPedidoSemAssinatura({ solicitacaoId })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public coberturaVigenteMensagem: string = ''

  @Mutation
  setCoberturaVigenteMensagem(value: string) {
    this.coberturaVigenteMensagem = value
  }

  @Action
  async consultaCoberturaVigenteBackoffice() {
    try {
      const procedimentoPrincipalId = this.solicitacao.procedimento!.id || ''
      const procedimentosAssociados = this.solicitacao.procedimentosAssociados ? this.solicitacao.procedimentosAssociados : []
      const procedimentosAssociadosIds = procedimentosAssociados.map((e: any) => e.id || '')
      const procedimentoIds: string[] = [procedimentoPrincipalId, ...procedimentosAssociadosIds]

      const params: any = {
        hospitalId: this.solicitacao.hospitalId,
        convenioId: this.solicitacao.paciente.convenioId,
        planoId: this.solicitacao.paciente.planoId,
        categoriaId: this.solicitacao.paciente.categoriaId,
        procedimentoIds,
      }

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.consultaCoberturaVigenteBackoffice(params)
      if (request.success) this.context.commit('setCoberturaVigenteMensagem', request.data.mensagem || '')
      return request
    } catch (error) {
      this.context.commit('setCoberturaVigenteMensagem', '')
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async consultaCoberturaVigente(resourceId = '') {
    try {
      const id = this.solicitacaoAlterada.hospital!.tipoDeCoberturaVigente === 'Categoria'
        ? this.solicitacaoAlterada.paciente.categoriaId
        : resourceId

      const params: any = {
        tipo: this.solicitacaoAlterada.hospital!.tipoDeCoberturaVigente,
        hospitalId: this.solicitacaoAlterada.hospital!.id,
        convenioId: this.solicitacaoAlterada.paciente.convenioId,
        planoId: this.solicitacaoAlterada.paciente.planoId,
        id,
      }

      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.consultaCoberturaVigente(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Mutation
  setProcedimentoPrincipalCoberturaVigente(procedimento: Procedimento) {
    if (procedimento) {
      this.solicitacaoAlterada.procedimento = { ...procedimento }
    }
  }

  @Mutation
  setProcedimentoAssociadoCoberturaVigente(procedimento: Procedimento) {
    const procedimentoIndex = this.solicitacaoAlterada.procedimentosAssociados!.findIndex((proc: Procedimento) => proc.id === procedimento.id) || 0
    this.solicitacaoAlterada.procedimentosAssociados![procedimentoIndex] = procedimento
  }

  @Mutation
  setCategoriaCoberturaVigente(value: boolean | undefined) {
    this.solicitacaoAlterada.paciente.categoriaCoberturaVigente = value
  }

  @Mutation
  clearCategoria() {
    this.solicitacaoAlterada.paciente.categoriaId = ''
  }

  /**
   * Tipo Acomodação
   */

  tipoAcomodacaoItems: Array<{ id: string, nome: string }> = [{ id: 'Apartamento', nome: 'Apartamento' }, { id: 'Enfermaria', nome: 'Enfermaria' }]

  @Mutation
  setTipoAcomodacaoItems(items: Array<{ id: string, nome: string }>) {
    this.tipoAcomodacaoItems = items
  }

  @Mutation
  clearTipoAcomodacaoItems() {
    this.tipoAcomodacaoItems = [{ id: 'Apartamento', nome: 'Apartamento' }, { id: 'Enfermaria', nome: 'Enfermaria' }]
  }

  @Action
  async getAllTipoAcomodacao(hospitalId: string) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllTipoAcomodacao(hospitalId)
      if (request.success) {
        this.context.commit('setTipoAcomodacaoItems', request.data
          .filter((item: any) => item.status === 'Ativo')
          .map((item: any) => ({ id: item.id, nome: item.descricao })))
      }
      return request
    } catch (error) {
      this.context.commit('setTipoAcomodacaoItems', [{ id: 'Apartamento', nome: 'Apartamento' }, { id: 'Enfermaria', nome: 'Enfermaria' }])
      return false
    }
  }

  @Action
  async imprimirEtiqueta(solicitacaoId: string) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.imprimirEtiqueta({
        solicitacaoId,
        tipo: 'ReservaDeOpmeEMedicamento',
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** PAÍSES */
  private paisesDefault: Pais[] = []
  public paises: Pais[] = [...this.paisesDefault]

  @Mutation
  setPaises(paises: Pais[]) {
    this.paises = paises
  }

  @Mutation
  clearPaises() {
    this.paises = [...this.paisesDefault]
  }

  @Action
  async getPaisAllWithHisId(hospitalId: string) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getPaisAllWithHisId(hospitalId)
      if (request.success) this.context.commit('setPaises', request.data as Pais[] || [])
      return request
    } catch (error) {
      this.context.commit('setPaises', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** Check needs use the default template or by assurance */
  get currentTemplate() {
    // Try get template by assurance
    const convenioId = this.solicitacaoAlterada.paciente && this.solicitacaoAlterada.paciente.convenioId
    if (convenioId) {
      if (this.template.porConvenios) {
        const templatePorConvenio = this.template.porConvenios.find((elem: any) => elem.convenioIds.includes(convenioId))
        if (templatePorConvenio) {
          return templatePorConvenio.template
        }
      }
    }

    // If not found by assurance, returns the default template
    return this.template
  }

  private hemocomponentesCheckboxDefault: string[] = []
  public hemocomponentesCheckbox: string[] = [...this.hemocomponentesCheckboxDefault]

  @Mutation
  setHemocomponentesCheckbox(value: string[]) {
    this.hemocomponentesCheckbox = value
  }

  @Mutation
  clearHemocomponentesCheckbox() {
    this.hemocomponentesCheckbox = [...this.hemocomponentesCheckboxDefault]
  }

  @Mutation
  clearHemocomponenteField(checkbox: string) {
    this.solicitacaoAlterada.reservaHemocomponentes[checkbox].quantidade = 0
    this.solicitacaoAlterada.reservaHemocomponentes[checkbox].value = false
  }

  @Action
  async postReservaHemocomponente(hemocomponente: Hemocomponente) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.postReservaHemocomponente(hemocomponente.solicitacaoId, hemocomponente)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async deleteReservaHemocomponente(tipo: string) {
    try {
      const solicitacaoId = this.solicitacao.id || this.solicitacaoAlterada.id
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteReservaHemocomponente(solicitacaoId, tipo)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }


  /** Guia Tiss Internação & Opme */
  private guiaTissInternacaoOpmeDefault: any = {
    convenioNome: null,
    agendaHisId: null,
    convenioRegistroANS: null,
    codigoEspecialidade: null,
    carteirinha: null,
    atendimentoRN: true,
    autorizacaoValidade: null,
    dataAutorizacao: null,
    operadoraSenha: null,
    autorizacaoDataPrevista: null,
    pacienteNome: null,
    nomeSocial: null,
    codigoNaOperadora: null,
    nomeDoContratado: null,
    medicoSolicitante: {
      nome: null,
      conselhoProfissional: null,
      conselhoTipo: null,
      conselhoNumero: null,
      conselhoUf: null,
      especialidade: null,
      codigoEspecialidade: null,
      carimboConselho: null,
      telefone: null,
      email: null,
      assinatura: null,
    },
    hospital: {
      nome: null,
      cnpj: null,
      cnes: null,
    },
    dataAgendamento: null,
    carater: null,
    tipoProcedimento: null,
    tipoProcedimentoEnum: null,
    diaria: 0,
    temPrevisaoUsoQuimioterapico: false,
    diagnosticoJustificativa: null,
    cids: [],
    indicacaoDeAcidente: null,
    procedimentos: [],
    reservaUTI: null,
    dataSolicitacao: null,
    grupoOpmeDaSolicitacao: [],
    hospitalRemoveParticularDaGuiaTiss: false,
    hospitalValidaHisIdDoFornecedorOpme: false,
  }

  public guiaTissInternacaoOpme: any = { ...this.guiaTissInternacaoOpmeDefault }

  @Mutation
  setGuiaTissInternacaoOpme(value: any) {
    this.guiaTissInternacaoOpme = {
      convenioNome: value.convenioNome || null,
      agendaHisId: value.agendaHisId || null,
      convenioRegistroANS: value.convenioRegistroANS || null,
      codigoEspecialidade: value.codigoEspecialidade || null,
      carteirinha: value.carteirinha || null,
      atendimentoRN: false,
      autorizacaoValidade: value.autorizacaoValidade || null,
      dataAutorizacao: value.dataAutorizacao || null,
      operadoraSenha: value.operadoraSenha || null,
      autorizacaoDataPrevista: value.autorizacaoDataPrevista || null,
      pacienteNome: value.pacienteNome || null,
      nomeSocial: value.nomeSocial || null,
      codigoNaOperadora: value.codigoNaOperadora || null,
      nomeDoContratado: value.hospitalNome || null,
      medicoSolicitante: {
        nome: value.medicoSolicitante.nome || null,
        conselhoProfissional: value.medicoSolicitante.conselhotTipo || null,
        conselhoTipo: value.medicoSolicitante.conselhoTipo || null,
        conselhoNumero: value.medicoSolicitante.conselhoNumero || null,
        conselhoUf: value.medicoSolicitante.conselhoUf || null,
        especialidade: value.medicoSolicitante.especialidade || null,
        codigoEspecialidade: value.medicoSolicitante.codigoEspecialidade || null,
        carimboConselho: value.medicoSolicitante.carimboConselho || null,
        telefone: value.medicoSolicitante.telefone || null,
        email: value.medicoSolicitante.email || null,
        assinatura: value.medicoSolicitante.urlAssinatura || null,
      },
      hospital: {
        nome: value.hospitalNome || null,
        cnpj: value.hospitalCNPJ || null,
        cnes: value.hospitalCNES || null,
      },
      dataAgendamento: value.dataAgendamento || null,
      carater: value.carater || null,
      tipoProcedimento: value.tipoProcedimento || null,
      tipoProcedimentoEnum: value.tipoProcedimentoEnum || null,
      diaria: value.diaria || 0,
      temPrevisaoUsoQuimioterapico: value.temPrevisaoUsoQuimioterapico || false,
      diagnosticoJustificativa: value.diagnosticoJustificativa || null,
      cids: value.cids || [],
      indicacaoDeAcidente: value.indicacaoDeAcidente || null,
      procedimentos: [value.procedimento, ...value.procedimentosAssociados],
      reservaUTI: value.reservaUTI || null,
      dataSolicitacao: value.dataSolicitacao || null,
      grupoOpmeDaSolicitacao: value.grupoOpmeDaSolicitacao || [],
      hospitalRemoveParticularDaGuiaTiss: value.hospitalRemoveParticularDaGuiaTiss || false,
    }
  }

  @Mutation
  clearGuiaTissInternacaoOpme() {
    this.guiaTissInternacaoOpme = { ...this.guiaTissInternacaoOpmeDefault }
  }

  get guiaTissGroupedByProcedimento() {
    const splittedData = this.guiaTissInternacaoOpme.procedimentos.reduce((acc: any, curr: any, index: number) => {
      if (index % 19 === 0) {
        acc.push({ ...this.guiaTissInternacaoOpme, procedimentos: [curr] })
      } else {
        acc[acc.length - 1].procedimentos.push(curr)
      }
      return acc
    }, []) || []
    return splittedData.length > 0 ? splittedData : [this.guiaTissInternacaoOpme]
  }

  get guiaTissGroupedByOpme() {
    if (this.guiaTissInternacaoOpme.grupoOpmeDaSolicitacao.length === 0) return [this.guiaTissInternacaoOpme]
    const splittedData = this.guiaTissInternacaoOpme.grupoOpmeDaSolicitacao[0].opmes.reduce((acc: any, opme: any, index) => {
      if (index % 12 === 0) {
        acc.push({
          ...this.guiaTissInternacaoOpme,
          grupoOpmeDaSolicitacao: [{
            id: this.guiaTissInternacaoOpme.grupoOpmeDaSolicitacao[0].id,
            tipo: this.guiaTissInternacaoOpme.grupoOpmeDaSolicitacao[0].tipo,
            opmes: [opme],
            solicitacaoCirurgiaId: this.guiaTissInternacaoOpme.grupoOpmeDaSolicitacao[0].solicitacaoCirurgiaId,
          }],
        })
      } else {
        acc[acc.length - 1].grupoOpmeDaSolicitacao[0].opmes.push(opme)
      }
      return acc
    }, []) || []
    return splittedData.length > 0 ? splittedData : [this.guiaTissInternacaoOpme]
  }

  @Action
  async getAllInformacoesParaGerarAGuiaTiss(params: { solicitacaoId: string, tipoDoTemplate: TipoDocumentoUpload }) {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllInformacoesParaGerarAGuiaTiss(params)
      if (request.success) {
        this.context.commit('setGuiaTissInternacaoOpme', {
          ...request.data.solicitacaoTemplate,
          hospitalRemoveParticularDaGuiaTiss: request.data.hospitalRemoveParticularDaGuiaTiss,
        })
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async gerarResumo(solicitacaoId: string = '') {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.gerarResumo(solicitacaoId || this.solicitacao.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async backofficeAtualizaOrcamentoParticular() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAtualizaOrcamentoParticular(this.solicitacao.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  /** ORCAMENTO PAGAMENTO */
  private orcamentoPagamentoDefault: any = {
    pagamentoId: '',
    valor: 0,
    metodoPagamento: '',
    dataPagamento: '',
  }

  public orcamentoPagamento: any = { ...this.orcamentoPagamentoDefault }

  @Mutation
  setOrcamentoPagamento(value: any) {
    this.orcamentoPagamento = value
  }

  @Mutation
  clearOrcamentoPagamento() {
    this.orcamentoPagamento = { ...this.orcamentoPagamentoDefault }
  }

  @Action
  async backofficeOrcamentoPagamento() {
    try {
      const params: any = { solicitacaoId: this.solicitacao.id, ...this.orcamentoPagamento }

      Object.entries(params).forEach(([key, value]) => {
        if (['', null, undefined].includes(value as any)) delete params[key]
      })

      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeOrcamentoPagamento(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}

export interface IBackofficeGlobalStoreEquipamento {
  equipamentosDaSolicitacao: EquipamentoGrupoDaSolicitacao[];
  equipamentosSugeridos: Equipamento[];
}

interface MaterialOptions {
  id: string,
  descricao: string,
  possuiGrade: boolean,
  disabled: boolean,
}
